/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, useEffect } from "react";
import { HeaderPage } from "../base/headerPage";
import { Label } from "@progress/kendo-react-labels";
import { MultiSelect, DropDownList } from "@progress/kendo-react-dropdowns";
import { Checkbox } from "@progress/kendo-react-inputs";
import { filterBy } from "@progress/kendo-data-query";
import { useDispatch } from "react-redux";
import CustomDropdown from "src/components/customDropdown";
import { getUserCredential } from "../../lib/cookies";
import { DatePicker, DateRangePicker } from "@progress/kendo-react-dateinputs";
import { Button } from "@progress/kendo-react-buttons";
import { TileLayout } from "@progress/kendo-react-layout";
import { Grid, GridNoRecords } from "@progress/kendo-react-grid";
import DataTable from "../../components/dataTable";
import { GridColumn as Column } from "@progress/kendo-react-grid";
import { columnMenuProps } from "../../components/customColumnMenu";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { useHistory } from "react-router-dom";
import ChartNavigation from "../../components/ChartNavigation";
import useChartNavigation from "../../hooks/useChartNavigation";

import "./index.scss";
import { formatDate, formatDateOnly, getfilterDataString, replaceBlankAndMerge } from "src/utils/utils";
import {
  Chart,
  ChartSeries,
  ChartSeriesItem,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartValueAxis,
  ChartValueAxisItem,
  ChartTitle,
  ChartLegend,
  ChartTooltip,
  ChartBreadcrumb,
  ChartXAxis,
  ChartXAxisItem,
  ChartYAxis,
  ChartYAxisItem,
} from "@progress/kendo-react-charts";
import userPositionApi from "./service";
import DtuBatchLogs from "../common/dtuBatchLogs";
import ManageCustomField from "../custom-fields/manage-custom-field";
import UploadDtu from "../user/uploadDtu";
import { Skeleton } from "@progress/kendo-react-indicators";
import { Card, CardHeader, CardFooter } from "@progress/kendo-react-layout";
import { Window } from "@progress/kendo-react-dialogs";
import { flashManagerIcon, toggleFullScreenModeIcon } from "@progress/kendo-svg-icons";
import { CHART_LAYOUT_OPTIONS, POSITION_PROVIDER_DROPDOWN } from "src/constants/constants";
import { timeout } from "rxjs";
import DraggableChart from "./DraggableChart";
const loadingPanel = (
  <div
    style={{
      flex: "1 1 50%",
    }}
  >
    <h5 class="chart-title">
      <Skeleton
        shape={"text"}
        style={{
          marginTop: "40px",
          width: "100%",
        }}
      />
    </h5>

    <Skeleton
      shape={"text"}
      style={{
        marginTop: "40px",
        width: "100%",
      }}
    />
    <Skeleton
      shape={"text"}
      style={{
        width: "40%",
      }}
    />
    <Skeleton
      shape="rectangle"
      style={{
        width: "100%",
        height: "100px",
        borderRadius: "8px",
        marginTop: "30px",
      }}
    />
  </div>
);

const TileLoader = () => (
  <div style={{ textAlign: "center" }}>
    {" "}
    <Card>
      <CardHeader className="k-hbox">
        <Skeleton
          shape={"circle"}
          style={{
            width: 45,
            height: 45,
            marginRight: 16,
          }}
        />
        <div
          style={{
            flex: "1 1 50%",
          }}
        >
          <Skeleton
            shape={"text"}
            style={{
              width: "100%",
            }}
          />
          <Skeleton
            shape={"text"}
            style={{
              width: "40%",
            }}
          />
        </div>
      </CardHeader>
    </Card>
  </div>
);

const renderKendoWindow = ({ visible, title, onClose, width = 800, height = 600, actions = ["Close"], children }) => {
  return (
    <Window
      initialOpen={false}
      title={title}
      onClose={onClose}
      initialHeight={height}
      initialWidth={width}
      className="dashboard-data-set-container"
      visible={visible}
      actions={actions}
      resizable={false}
      titleClassName="dashboard-data-set-title"
    >
      {children}
    </Window>
  );
};

const parseCardList = (cardRes) => {
  if (!cardRes) return [];
  if (Array.isArray(cardRes)) return cardRes;
  if (typeof cardRes === "string") {
    try {
      const parsed = JSON.parse(cardRes);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

const DASHBOARD_TILE_TOOLTIPS = {
  Providers: "Total active providers as of today",
  "New Hires": "Providers hired in the last 12 months",
  Terminated: "Providers terminated in the last 12 months",
  Groups: "Total number of provider groups",
  Specialty: "Total number of specialties",
};

const getDashboardTileTooltip = (label) => DASHBOARD_TILE_TOOLTIPS[label] || "Shows the count for this metric";

const getEmptyTiles = () =>
  Array.from({ length: 5 }).map(() => ({
    header: "",
    body: <TileLoader />,
    reorderable: false,
  }));

const buildDashboardTiles = (cardList, history) =>
  cardList.map((item) => ({
    header: (
      <>
        {item.label === "Providers" && (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#2EA8E5"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="7" r="4" />
            <path d="M5 21c0-4 3-7 7-7s7 3 7 7" />
          </svg>
        )}
        {item.label === "New Hires" && (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#2EA8E5"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="9" cy="7" r="4" />
            <path d="M2 21c0-4 3-7 7-7" />
            <line x1="19" y1="8" x2="19" y2="14" />
            <line x1="16" y1="11" x2="22" y2="11" />
          </svg>
        )}
        {item.label === "Terminated" && (
          <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" stroke-width="0" />
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path
                d="M4 21C4 17.134 7.13401 14 11 14C11.695 14 12.3663 14.1013 13 14.2899M20 18L14 18M15 7C15 9.20914 13.2091 11 11 11C8.79086 11 7 9.20914 7 7C7 4.79086 8.79086 3 11 3C13.2091 3 15 4.79086 15 7Z"
                stroke="#00a1e4"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />{" "}
            </g>
          </svg>
        )}
        {item.label === "Specialty" && (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#2EA8E5"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="3" y="3" width="18" height="18" rx="4" />
            <path d="M12 8v8M8 12h8" />
          </svg>
        )}
        {item.label === "Groups" && (
          <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path
                d="M3 19V18C3 15.7909 4.79086 14 7 14H11C13.2091 14 15 15.7909 15 18V19M15 11C16.6569 11 18 9.65685 18 8C18 6.34315 16.6569 5 15 5M21 19V18C21 15.7909 19.2091 14 17 14H16.5M12 8C12 9.65685 10.6569 11 9 11C7.34315 11 6 9.65685 6 8C6 6.34315 7.34315 5 9 5C10.6569 5 12 6.34315 12 8Z"
                stroke="#00a1e4"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>{" "}
            </g>
          </svg>
        )}

        <Tooltip title={getDashboardTileTooltip(item.label)} anchorElement="target" position="bottom" openDelay={100}>
          <span>{item.label}</span>
        </Tooltip>
      </>
    ),
    body: (
      <div style={{ textAlign: "center" }}>
        <h3 className="darkgraytitle hover-wrapper">
          {item.label !== "Groups" && item.label !== "Specialty" ? (
            (() => {
              const isZeroForNonNavigableLabel =
                (item.label === "New Hires" || item.label === "Terminated") && Number(item.value) === 0;

              if (isZeroForNonNavigableLabel) {
                return <span>{item.value}</span>;
              }

              return (
                <Tooltip anchorElement="target" position="bottom" openDelay={100}>
                  <span
                    title={getDashboardTileTooltip(item.label)}
                    style={{
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                    onClick={() => {
                      let selectedItem = "Effective Date - Current";
                      let dateRange = "Up To Date";

                      if (item.label === "Terminated") {
                        selectedItem = "Terminated Date - Current";
                        dateRange = "Rolling 12 Months";
                      } else if (item.label === "New Hires") {
                        selectedItem = "Hire Date - Current";
                        dateRange = "Rolling 12 Months";
                      }

                      history.push("/prv_pos", {
                        selectedItem,
                        dateRange,
                      });
                    }}
                  >
                    {item.value}
                  </span>
                </Tooltip>
              );
            })()
          ) : (
            <span>{item.value}</span>
          )}
        </h3>
      </div>
    ),
    reorderable: false,
    resizable: false,
  }));
const ProviderDashboard = (restProps) => {
  const dispatch = useDispatch();
  const cookiesData = getUserCredential();
  const history = useHistory();

  const divRef = useRef();
  const dateRef = useRef();
  const labelToChartIdMap = {
    provider_status_by_comp_plan: "providerStatus",
    active_providers_by_specialty: "activeProviders",
    provider_status_by_specialty: "providerSpecialty",
    provider_age: "providerageexperience",
    provider_turnover: "providerturnover",
    provider_count: "providerCount",
  };
  const chartIdToLabelMap = Object.fromEntries(
    Object.entries(labelToChartIdMap).map(([label, chartId]) => [chartId, label])
  );

  const ALL_LAYOUT_OPTIONS = CHART_LAYOUT_OPTIONS;
  const TWO_LAYOUT_OPTIONS = CHART_LAYOUT_OPTIONS.filter((opt) => opt.parse_value <= 2);

  const [list, Action] = userPositionApi();
  const [isShow, setShow] = React.useState({
    isManageCustomType: false,
    dtuLogs: false,
    dtuUpload: false,
  });
  const [providerPositionValue, setproviderPositionValue] = React.useState({
    text: "Providers",
    value: 1,
  });
  const [providerPositionValueSpeclity, setproviderPositionValueSpeclity] = React.useState({
    text: "Providers",
    value: 1,
  });
  const [isSpecialtyOutlierFilterEnabled, setIsSpecialtyOutlierFilterEnabled] = React.useState(true);
  const [providerCharts, setProviderCharts] = React.useState({
    providerChartFields: CHART_LAYOUT_OPTIONS[0],
    providerChartLabel: "provider_status_by_comp_plan",
  });
  const [providerSpecialtyCharts, setProviderSpecialtyCharts] = React.useState({
    providerSpChartFields: CHART_LAYOUT_OPTIONS[0],
    providerSpChartLabel: "active_providers_by_specialty",
  });
  const [activeProviderCharts, setActiveProviderCharts] = React.useState({
    providerActiveChartFields: CHART_LAYOUT_OPTIONS[0],
    providerActiveChartLabel: "provider_status_by_specialty",
  });
  const [providerTrendCharts, setProviderTrendCharts] = React.useState({
    providerTrendChartFields: CHART_LAYOUT_OPTIONS[0],
    providerTrendChartLabel: "provider_trend",
  });
  const [topProviderGroupCharts, setTopProviderGroupCharts] = React.useState({
    providerTopGroupChartFields: CHART_LAYOUT_OPTIONS[0],
    providerTopGroupChartLabel: "top_provider_group",
  });
  const [topProviderSpecialtyCharts, setTopProviderSpecialtyCharts] = React.useState({
    providerTopSpecialtyChartFields: CHART_LAYOUT_OPTIONS[0],
    providerTopSpecialtyChartLabel: "top_provider_specialty",
  });
  const [providerRrententionCharts, setProviderRrententionCharts] = React.useState({
    providerRrententionChartsFields: CHART_LAYOUT_OPTIONS[0],
    providerRrententionChartsLabel: "provider_retention",
  });
  const [providerAttritionCharts, setProviderAttritionCharts] = React.useState({
    providerAttritionChartsFields: CHART_LAYOUT_OPTIONS[0],
    providerAttritionChartsLabel: "provider_attrition",
  });

  const [providerAgeExperienceCharts, setProviderAgeExperienceCharts] = React.useState({
    providerAgeExperienceChartsFields: CHART_LAYOUT_OPTIONS[2],
    providerAgeExperienceChartsLabel: "provider_age",
  });
  const [providerTurnoverDataCharts, setProviderTurnoverDataCharts] = React.useState({
    providerTurnoverDataChartsFields: CHART_LAYOUT_OPTIONS[1],
    providerTurnoverDataChartsLabel: "provider_turnover",
  });
  const [providerArDataCharts, setProviderArDataCharts] = React.useState({
    providerCountDataChartsFields: CHART_LAYOUT_OPTIONS[0],
    providerCountDataChartsLabel: "provider_count",
  });
  const [chartOrder, setChartOrder] = React.useState([
    "providerStatus",
    "activeProviders",
    "providerSpecialty",
    "providerageexperience",
    "providerturnover",
    "providerCount",
  ]);
  const [drilldownState, setDrilldownState] = React.useState();
  const [tooltipVisible, setTooltipVisible] = React.useState(true);
  const [ageValue, setAgeValue] = React.useState();
  const [regionValue, setRegionValue] = React.useState();
  const [drilldownData, setDrilldownData] = React.useState(null);
  const [drilldownXcategoryData, setDrilldownXcategoryData] = React.useState(null);
  const [drilldownYcategoryData, setDrilldownYcategoryData] = React.useState(null);

  const [drilldownTitle, setDrilldownTitle] = React.useState("");

  const {
    specialtyDataList,
    specialtyDataFields,
    setSpecialtyDataFields,
    getSpecialtyDataList,
    groupDataFields,
    setGroupDataFields,
    getGroupDataList,
    groupDataList,
    positionDataFields,
    positionDataList,
    setPositionDataFields,
    employeeDataFields,
    employeeDataList,
    setEmployeeDataFields,
    npiDataFields,
    npiDataList,
    setNpiDataFields,
    timePeriodData,
    setTimePeriodData,
    originalTimePeriodData,
    coloumnData,
    data,
    categories,
    series,
    providerTypeSeries,
    providerTypeCategories,
    providerValueAxisMax,
    providerValueAxisMajorUnit,
    providerCardData,
    positionTypeSeries,
    positionTypeCategories,
    providerTypeColors,
    isPositionDataLoading,
    isProviderStatusAndPlanDataLoading,
    isSpecialtyPositionDataLoading,
    setIsProviderStatusAndPlanDataLoading,
    setIsSpecialtyPositionDataLoading,
    setIsPositionDataLoading,
    valueAxisMax,
    valueAxisMajorUnit,
    setSeries,
    isGroupSpecialtyPositionDataLoading,
    groupPositionTypeSeries,
    groupProviderTypeColors,
    specialtyProviderTypeColors,
    specialtyPositionTypeSeries,
    speclityCategories,
    setspeclityCategories,
    speclitySeries,
    setspeclitySeries,
    speclityValueAxisMax,
    setspeclityValueAxisMax,
    speclityValueAxisMajorUnit,
    setspeclityValueAxisMajorUnit,
    isspeclityProviderStatusAndPlanDataLoading,
    speclityAPICallingState,
    setspeclityAPICallingState,
    speclityLoadingState,
    setspeclityLoadingState,
    speclityNoDataFound,
    setspeclityNoDataFound,
    ProviderspeclityPlanStatusData,
    setProviderspeclityPlanStatusData,
    setProviderTypeSeries,
    setisspeclityProviderStatusAndPlanDataLoading,
    setIsGroupSpecialtyPositionDataLoading,
    groupValueAxisMax,
    groupValueAxisMajorUnit,
    specialityValueAxisMax,
    specialityValueAxisMajorUnit,
    setGroupPositionTypeSeries,
    setSpecialtyPositionTypeSeries,
    providerSummaryData,
    providerSummaryCategories,
    providerSummaryLoading,
    providerSummaryValueAxisMax,
    providerSummaryValueAxisMajorUnit,
    providerSummaryColors,
    setProviderSummaryData,
    providerRetentionLoading,
    rowData,
    groupedData,
    xMax,
    yMax,
    setGroupedData,
    providerDonutData,
    setProviderDonutData,
    setProviderSummaryLoading,
    setProviderRetentionLoading,
    setAttritionChartLoading,
    attritionChartLoading,
    attritionCategories,
    setAttritionCategories,
    attritionActiveHeadcount,
    setAttritionActiveHeadcount,
    attritionRate,
    setAttritionRate,
    setAttritionSeries,
    attritionSeries,
    providerAgeExperienceData,
    providerAgeExperienceXCategories,
    providerAgeExperienceYCategories,
    providerAgeExperienceLoading,
    setProviderAgeExperienceLoading,
    setProviderAgeExperienceData,
    setProviderAgeExperienceXCategories,
    setProviderAgeExperienceYCategories,
    turnoverChartLoading,
    setTurnoverChartLoading,
    turnoverCategories,
    setTurnoverCategories,
    turnoverSeries,
    setTurnoverSeries,
    providerAgeExperienceDetailData,
    providerAgeExperienceDetailXCategories,
    providerAgeExperienceDetailYCategories,
    providerAgeExperienceDetailLoading,
    setProviderAgeExperienceDetailLoading,
    setProviderAgeExperienceDetailData,
    setProviderAgeExperienceDetailXCategories,
    setProviderAgeExperienceDetailYCategories,
    providerARCategories,
    providerARSeries,
    providerARChartLoading,
    providerARNoDataFound,
    setProviderARCategories,
    setProviderARSeries,
    providerArDataChartsLoading,
    setProviderARNoDataFound,
    setProviderARChartLoading,
  } = list;
  const [customRange, setCustomRange] = React.useState({
    start: null,
    end: null,
  });
  const [tiles, setTiles] = React.useState(
    Array.from({ length: 5 }).map((_, index) => ({
      header: "",
      body: <TileLoader />,
      reorderable: false,
    }))
  );
  const [gridColumns, setGridColumns] = React.useState([]);
  const [refreshChart, setRefreshChart] = React.useState(false);
  const [refreshpositionTypeChart, setRefreshpositionTypeChart] = React.useState(false);
  const [layoutVersion, setLayoutVersion] = React.useState(0);

  const [refreshProviderChart, setRefreshProviderChart] = React.useState(false);
  const [refreshSpecialtyProviderChart, setRefreshSpecialtyProviderChart] = React.useState(false);
  const [refreshCompSpecialtyProviderChart, setRefreshCompSpecialtyProviderChart] = React.useState(false);
  const [refreshProviderSummaryChart, setRefreshProviderSummaryChart] = React.useState(false);
  const [refreshProviderRetentionChart, setRefreshProviderRetentionChart] = React.useState(false);
  const [refreshProviderAttritionChart, setRefreshProviderAttritionChart] = React.useState(false);
  const [refreshProviderAgeExperienceChart, setRefreshProviderAgeExperienceChart] = React.useState(false);
  const [refreshProviderTurnoverChart, setRefreshProviderTurnoverChart] = React.useState(false);
  const [isWindowOpen, setIsWindowOpen] = React.useState(false);
  const [isWindowOpenForProviderandSpecialtyChart, setIsWindowOpenForProviderandSpecialtyChart] = React.useState(false);
  const [isWindowOpenForTopProviderChart, setIsWindowOpenForTopProviderChart] = React.useState(false);
  const [isWindowOpenForTopProviderSpecialtyChart, setIsWindowOpenForTopProviderSpecialtyChart] = React.useState(false);
  const [isWindowOpenForProviderandSpecialtyChartByStatus, setIsWindowOpenForProviderandSpecialtyChartByStatus] =
    React.useState(false);
  const [isWindowOpenForProviderTrendChart, setIsWindowOpenForProviderTrendChart] = React.useState(false);
  const [isWindowOpenForProviderRetentionChart, setIsWindowOpenForProviderRetentionChart] = React.useState(false);
  const [isWindowOpenForProviderAttritionChart, setIsWindowOpenForProviderAttritionChart] = React.useState(false);
  const [isWindowOpenForProviderAgeExperienceChart, setIsWindowOpenForProviderAgeExperienceChart] =
    React.useState(false);
  const [isWindowOpenForProviderTurnoverChart, setIsWindowOpenForProviderTurnoverChart] = React.useState(false);
  const [isWindowOpenForProviderArChart, setIsWindowOpenForProviderArChart] = React.useState(false);
  const [refreshProviderARChart, setRefreshProviderARChart] = React.useState(false);

  const resetAllRefreshFlags = React.useCallback(() => {
    setRefreshChart(false);
    setRefreshProviderChart(false);
    setRefreshpositionTypeChart(false);
    setRefreshSpecialtyProviderChart(false);
    setRefreshCompSpecialtyProviderChart(false);
    setRefreshProviderSummaryChart(false);
    setRefreshProviderRetentionChart(false);
    setRefreshProviderAttritionChart(false);
    setRefreshProviderAgeExperienceChart(false);
    setRefreshProviderTurnoverChart(false);
    setRefreshProviderARChart(false);
  }, []);

  const pulseRefresh = React.useCallback((setRefreshFn) => {
    setRefreshFn(true);
    setTimeout(() => setRefreshFn(false), 100);
  }, []);

  const [providerChartWidthPercent, setProviderChartWidthPercent] = React.useState(null);
  const [specialtyChartWidthPercent, setSpecialtyChartWidthPercent] = React.useState(null);
  const [ageAnalysisChartWidthPercent, setAgeAnalysisChartWidthPercent] = React.useState(null);
  const [turnoverChartWidthPercent, setTurnoverChartWidthPercent] = React.useState(null);
  const [providerCountChartWidthPercent, setProviderCountChartWidthPercent] = React.useState(null);

  const getItemsCountByWidth = (layoutOption, actualWidthPercent = null) => {
    if (actualWidthPercent !== null) {
      if (actualWidthPercent >= 85) return 15;
      if (actualWidthPercent >= 55) return 10;
      return 5;
    }

    if (!layoutOption?.parse_value) return 5;
    switch (layoutOption.parse_value) {
      case 1:
        return 15;
      case 2:
        return 10;
      case 3:
        return 5;
      default:
        return 5;
    }
  };

  const providerChartElementRef = React.useRef(null);
  const providerChartRefCallback = React.useCallback((element) => {
    providerChartElementRef.current = element;
  }, []);

  const activeProviderChartElementRef = React.useRef(null);
  const activeProviderChartRefCallback = React.useCallback((element) => {
    activeProviderChartElementRef.current = element;
  }, []);

  const specialtyChartElementRef = React.useRef(null);
  const specialtyChartRefCallback = React.useCallback((element) => {
    specialtyChartElementRef.current = element;
  }, []);
  const specialtyChartOutlierState = React.useMemo(() => {
    const rawCategories = speclityCategories || [];
    const rawSeries = speclitySeries || [];
    const visibleSeries = rawSeries.filter((s) => s.visible !== false);
    const totals = rawCategories.map((category, index) => ({
      category,
      index,
      total: visibleSeries.reduce((sum, seriesItem) => sum + (Number(seriesItem?.data?.[index]) || 0), 0),
    }));
    const defaultCategoryTotal = totals.find(
      (item) =>
        String(item.category || "")
          .trim()
          .toLowerCase() === "default"
    );
    const shouldExcludeOutlier = rawCategories.length > 1 && defaultCategoryTotal;

    return {
      categories: shouldExcludeOutlier
        ? rawCategories.filter((_, index) => index !== defaultCategoryTotal.index)
        : rawCategories,
      excludedCategory: shouldExcludeOutlier ? defaultCategoryTotal : null,
    };
  }, [speclityCategories, speclitySeries]);
  const specialtyChartNavigationCategories =
    isSpecialtyOutlierFilterEnabled && specialtyChartOutlierState.excludedCategory
      ? specialtyChartOutlierState.categories
      : speclityCategories;

  const ageAnalysisChartElementRef = React.useRef(null);
  const ageAnalysisChartRefCallback = React.useCallback((element) => {
    ageAnalysisChartElementRef.current = element;
  }, []);

  const turnoverChartElementRef = React.useRef(null);
  const turnoverChartRefCallback = React.useCallback((element) => {
    turnoverChartElementRef.current = element;
  }, []);

  const providerCountChartElementRef = React.useRef(null);
  const providerCountChartRefCallback = React.useCallback((element) => {
    providerCountChartElementRef.current = element;
  }, []);

  const providerChartItemsCount = getItemsCountByWidth(providerCharts.providerChartFields, providerChartWidthPercent);
  const providerChartNav = useChartNavigation(0, providerChartItemsCount, categories);
  const providerChartNavExpanded = useChartNavigation(0, 15, categories);

  const specialtyChartItemsCount = getItemsCountByWidth(
    providerSpecialtyCharts.providerSpChartFields,
    specialtyChartWidthPercent
  );
  const specialtyChartNav = useChartNavigation(0, specialtyChartItemsCount, specialtyChartNavigationCategories);
  const specialtyChartNavExpanded = useChartNavigation(0, 15, specialtyChartNavigationCategories);

  const ageAnalysisMainChartItemsCount = getItemsCountByWidth(
    providerAgeExperienceCharts.providerAgeExperienceChartsFields,
    ageAnalysisChartWidthPercent
  );
  const ageAnalysisMainChartNav = useChartNavigation(
    0,
    ageAnalysisMainChartItemsCount,
    providerAgeExperienceXCategories
  );
  const ageAnalysisMainChartNavExpanded = useChartNavigation(0, 15, providerAgeExperienceXCategories);

  const ageAnalysisDrilldownChartItemsCount = getItemsCountByWidth(
    providerAgeExperienceCharts.providerAgeExperienceChartsFields,
    ageAnalysisChartWidthPercent
  );
  const ageAnalysisDrilldownChartNav = useChartNavigation(
    0,
    ageAnalysisDrilldownChartItemsCount,
    drilldownXcategoryData || []
  );
  const ageAnalysisDrilldownChartNavExpanded = useChartNavigation(0, 15, drilldownXcategoryData || []);

  const ageAnalysisDrilldownChartYAxisNav = useChartNavigation(0, 10, drilldownYcategoryData || []);
  const ageAnalysisDrilldownChartYAxisNavExpanded = useChartNavigation(0, 15, drilldownYcategoryData || []);

  const turnoverChartItemsCount = getItemsCountByWidth(
    providerTurnoverDataCharts.providerTurnoverDataChartsFields,
    turnoverChartWidthPercent
  );
  const turnoverChartNav = useChartNavigation(0, turnoverChartItemsCount, turnoverCategories);
  const turnoverChartNavExpanded = useChartNavigation(0, 15, turnoverCategories);

  const providerCountChartItemsCount = getItemsCountByWidth(
    providerArDataCharts.providerCountDataChartsFields,
    providerCountChartWidthPercent
  );
  const providerCountChartNav = useChartNavigation(0, providerCountChartItemsCount, providerARCategories);
  const providerCountChartNavExpanded = useChartNavigation(0, 15, providerARCategories);

  const hasRunRef = React.useRef(false);

  React.useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (providerChartElementRef.current) {
        const width = providerChartElementRef.current.offsetWidth;
        const parentWidth = providerChartElementRef.current.parentElement?.offsetWidth || width;
        setProviderChartWidthPercent((width / parentWidth) * 100);
        setRefreshProviderChart(true);
        setTimeout(() => setRefreshProviderChart(false), 100);
      }

      if (activeProviderChartElementRef.current) {
        setRefreshpositionTypeChart(true);
        setTimeout(() => setRefreshpositionTypeChart(false), 100);
      }

      if (specialtyChartElementRef.current) {
        const width = specialtyChartElementRef.current.offsetWidth;
        const parentWidth = specialtyChartElementRef.current.parentElement?.offsetWidth || width;
        setSpecialtyChartWidthPercent((width / parentWidth) * 100);
        setRefreshCompSpecialtyProviderChart(true);
        setTimeout(() => setRefreshCompSpecialtyProviderChart(false), 100);
      }

      if (ageAnalysisChartElementRef.current) {
        const width = ageAnalysisChartElementRef.current.offsetWidth;
        const parentWidth = ageAnalysisChartElementRef.current.parentElement?.offsetWidth || width;
        setAgeAnalysisChartWidthPercent((width / parentWidth) * 100);
        setRefreshProviderAgeExperienceChart(true);
        setTimeout(() => setRefreshProviderAgeExperienceChart(false), 100);
      }

      if (turnoverChartElementRef.current) {
        const width = turnoverChartElementRef.current.offsetWidth;
        const parentWidth = turnoverChartElementRef.current.parentElement?.offsetWidth || width;
        setTurnoverChartWidthPercent((width / parentWidth) * 100);
        setRefreshProviderTurnoverChart(true);
        setTimeout(() => setRefreshProviderTurnoverChart(false), 100);
      }

      if (providerCountChartElementRef.current) {
        const width = providerCountChartElementRef.current.offsetWidth;
        const parentWidth = providerCountChartElementRef.current.parentElement?.offsetWidth || width;
        setProviderCountChartWidthPercent((width / parentWidth) * 100);
        setRefreshProviderARChart(true);
        setTimeout(() => setRefreshProviderARChart(false), 100);
      }
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [
    providerCharts.providerChartFields,
    activeProviderCharts.providerActiveChartFields,
    providerSpecialtyCharts.providerSpChartFields,
    providerAgeExperienceCharts.providerAgeExperienceChartsFields,
    providerTurnoverDataCharts.providerTurnoverDataChartsFields,
    providerArDataCharts.providerCountDataChartsFields,
  ]);

  React.useEffect(() => {
    const loadDropdownsSequentially = async () => {
      await handleOpenDropdown("chart-order");
      await handleOpenDropdown("providerDashboard");
      await handleOpenDropdown("recent-filter");
    };

    loadDropdownsSequentially();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const loadGridViewFilters = async () => {
      await Promise.all([
        Action.getSpecialtyDataList(),
        Action.getGroupDataList(),
        Action.getEmployeeDataList(),
        Action.getNpiDataList(),
        Action.getPostionDataList(),
      ]);
    };

    loadGridViewFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getChartOptionByLayout = (layout_value) => {
    return CHART_LAYOUT_OPTIONS.find((opt) => opt.parse_value === Number(layout_value)) || CHART_LAYOUT_OPTIONS[0];
  };

  const applyLayoutSettings = (apiData) => {
    apiData.forEach((item) => {
      const option = getChartOptionByLayout(item.layout_value);

      switch (item.label_name) {
        case "provider_status_by_comp_plan":
          setProviderCharts((prev) => ({
            ...prev,
            providerChartFields: option,
          }));
          break;

        case "active_providers_by_specialty":
          setActiveProviderCharts((prev) => ({
            ...prev,
            providerActiveChartFields: option,
          }));
          break;

        case "provider_status_by_specialty":
          setProviderSpecialtyCharts((prev) => ({
            ...prev,
            providerSpChartFields: option,
          }));
          break;

        case "provider_trend":
          setProviderTrendCharts((prev) => ({
            ...prev,
            providerTrendChartFields: option,
          }));
          break;

        case "top_provider_group":
          setTopProviderGroupCharts((prev) => ({
            ...prev,
            providerTopGroupChartFields: option,
          }));
          break;

        case "top_provider_specialty":
          setTopProviderSpecialtyCharts((prev) => ({
            ...prev,
            providerTopSpecialtyChartFields: option,
          }));
          break;

        case "provider_retention":
          setProviderRrententionCharts((prev) => ({
            ...prev,
            providerRrententionChartsFields: option,
          }));
          break;

        case "provider_attrition":
          setProviderAttritionCharts((prev) => ({
            ...prev,
            providerAttritionChartsFields: option,
          }));
          break;

        case "provider_age":
          setProviderAgeExperienceCharts((prev) => ({
            ...prev,
            providerAgeExperienceChartsFields: option,
          }));
          break;

        case "provider_turnover":
          setProviderTurnoverDataCharts((prev) => ({
            ...prev,
            providerTurnoverDataChartsFields: option,
          }));
          break;

        default:
          break;
      }
    });
  };
  const handleOpenDropdown = async (module) => {
    switch (module) {
      case "chart-order":
        const landingData = {
          in_tenant_id: cookiesData.out_tenant_id,
          in_filter: null,
          in_sort_number: 1,
          in_sort_order: "DESC",
        };
        let landingdata = await Action.GetLandingDashboardData(landingData);
        let chartIdMap = {};
        const ordered = landingdata
          .sort((a, b) => a.pod_order - b.pod_order)
          .map((item) => labelToChartIdMap[item.label_name])
          .filter(Boolean);

        applyLayoutSettings(landingdata);

        setChartOrder(ordered);
        break;

      case "recent-filter":
        const reqData = {
          in_tenant_id: cookiesData.out_tenant_id,
          in_filter: null,
          in_sort_number: 1,
          in_sort_order: "DESC",
          in_page_row_offset: 0,
          in_page_rows: 9999,
          in_user_id: cookiesData.out_user_id,
          in_db_obj_code: "events",
        };

        await Action.GetFilterQuery(reqData);

      default:
        break;
    }
  };

  const parseDateRange = (data) => {
    if (!data?.value || typeof data.value !== "string") {
      return { start: null, end: null };
    }

    const [start, end] = data.value.split(" - ");
    return {
      start: start?.split(" ")[0] || null,
      end: end?.split(" ")[0] || null,
    };
  };
  React.useEffect(() => {
    const fetchData = async () => {
      if (hasRunRef.current) return;
      hasRunRef.current = true;

      const providerapiParam = {
        in_tenant_id: cookiesData.out_tenant_id,
        in_user_key: cookiesData.out_user_id,
        in_org_title_key: null,
        in_specialty_mstr_key: null,
        in_provider_mstr_key: null,
        in_input_type: 1,
      };

      const baseTableData = {
        in_user_key: cookiesData.out_user_id,
      };

      const ProviderArData = {
        in_tenant_id: cookiesData.out_tenant_id,
        in_filter: null,
        in_period_name: null,
        in_user_key: cookiesData.out_user_id,
      };

      try {
        const tableDataRes = await Action.GetProviderBaseTableData(baseTableData);

        if (!tableDataRes) {
          console.warn("Skipping other API calls because GetProviderBaseTableData returned false/invalid.");
          return;
        }

        const cardListPromise = Action.getProviderDashboardCardData(providerapiParam);

        const otherApisPromise = Promise.all([
          Action.getProviderStatusAndPlanData(providerapiParam),
          Action.getProviderSpeclityStatusAndPlanData(providerapiParam),
          Action.getPositionTypeData(providerapiParam),
          Action.getProviderChartAttritionData(providerapiParam),
          Action.GetProviderChartAgeVsExperience(providerapiParam),
          Action.getProviderChartTurnoverData(providerapiParam),
          Action.GetProviderChartARData(ProviderArData),
        ]);

        const cardList = await cardListPromise;
        setTiles(buildDashboardTiles(parseCardList(cardList), history));

        await otherApisPromise;
      } catch (error) {
        console.error("Error during API calls:", error);
      }
    };

    fetchData();
  }, []);

  React.useEffect(() => {
    if (coloumnData.length > 0) {
      setGridColumns(coloumnData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coloumnData]);

  const useCol = (columns) => {
    return columns.map((column, idx) => {
      return column.show &&
        column.title !== "" &&
        column.field !== "grid_filter_history_key" &&
        column.field !== "is_favorite" &&
        column.field !== "favorite_date" &&
        column.field !== "filter_text" ? (
        <Column {...columnMenuProps(column)} key={idx} cell={""} sortable={true} />
      ) : (
        false
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  let GroupColumn = useCol(gridColumns);

  const filterChange = (event, setDataFields, moduleData, key) => {
    let dataValue = filterBy(moduleData.slice(), event.filter);
    setDataFields((prev) => ({
      ...prev,
      [`${key}`]: dataValue,
      filterValue: event.filter.value,
      search: event.filter,
    }));
  };

  const onOpenChange = (setDataFields, moduleData, key, dataFields, dataFieldsValue) => {
    resetAllRefreshFlags();
    let dataValue =
      dataFields.filterValue && dataFields.filterValue !== ""
        ? filterBy(dataFieldsValue.slice(), dataFields.search)
        : moduleData;
    setDataFields((prev) => ({
      ...prev,
      [`${key}`]: dataValue,
    }));
  };

  const handleChangeDropdownValue = (e, name, setDataFields, dataList, valueData, dataFields) => {
    resetAllRefreshFlags();
    if (valueData && valueData.filter((x) => x.text === "Select All").length > 0) {
      let index = e.value.findIndex((x) => x.text === "Select All");
      e.value.splice(index, 1);
    } else if (e.value && e.value.filter((x) => x.text === "Select All").length > 0 && e.value.length > 1) {
      e.value = [];
      e.value.push({ text: "Select All", id: "Select All" });
    }
    if (e.value.length === 0) {
      e.value.push({ text: "Select All", id: "Select All" });
    }

    handleOnChange(e.value, name, setDataFields, dataList, dataFields);
  };

  const handleOnChange = async (e, name, setDataFields, dataList, dataFields) => {
    let dataValue = [];
    if (e.length === 1 && e.some((x) => x.text === "Select All")) {
      dataValue.push({ text: "Select All", id: "Select All" });
    } else {
      dataValue = [...e];
    }
    setDataFields({
      ...dataFields,
      [name]: dataValue,
    });

    if (name === "specialtyDataValue") {
      await Action.getGroupDataList(e);
      await Action.getEmployeeDataList(e);
      await Action.getNpiDataList(e);
      await Action.getPostionDataList(e);
    } else if (name === "groupDataValue") {
      await Action.getEmployeeDataList(specialtyDataFields.specialtyDataValue, e);
      await Action.getNpiDataList(specialtyDataFields.specialtyDataValue, e);
      await Action.getPostionDataList(specialtyDataFields.specialtyDataValue, e);
    }
  };

  const handleBlurDropdown = (setDataFields, key) => {
    setDataFields((prev) => ({
      ...prev,
      filterValue: "",
      search: "",
    }));
  };

  const getApiValue = (arr) => {
    if (!Array.isArray(arr) || arr.length === 0) return null;
    const filtered = arr.filter((item) => item.id !== "Select All");
    if (filtered.length === 0) return null;
    return filtered.map((item) => item.id).join(",");
  };

  const isGridViewFilterLoading =
    specialtyDataFields.isSpecialtyDataLoading ||
    groupDataFields.isGroupDataLoading ||
    employeeDataFields.isEmployeeDataLoading ||
    npiDataFields.isNpiDataLoading ||
    positionDataFields.isPositionDataLoading;

  const handleGridViewSearch = () => {
    history.push("/prv_pos", {
      providerDashboardFilters: {
        specialtyValue: specialtyDataFields.specialtyDataValue,
        groupValue: groupDataFields.groupDataValue,
        employeeValue: employeeDataFields.employeeDataValue,
        npiValue: npiDataFields.npiDataValue,
        positionValue: positionDataFields.positionDataValue,
      },
    });
  };

  const onUpdateChartClick = async () => {
    setTiles(getEmptyTiles());
    resetAllRefreshFlags();
    setIsProviderStatusAndPlanDataLoading(true);
    setIsPositionDataLoading(true);
    setisspeclityProviderStatusAndPlanDataLoading(true);
    setProviderSummaryLoading(true);
    setProviderRetentionLoading(true);
    setAttritionChartLoading(true);
    setProviderAgeExperienceLoading(true);
    setTurnoverChartLoading(true);
    setProviderARChartLoading(true);

    const parsedRange =
      timePeriodData.timePeriodValue?.text === "custom_range"
        ? { start: formatDateOnly(customRange.start), end: formatDateOnly(customRange.end) }
        : parseDateRange(timePeriodData.timePeriodValue);

    const providerapiParam = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_user_key: cookiesData.out_user_id,
      in_org_title_key: getApiValue(groupDataFields.groupDataValue),
      in_specialty_mstr_key: getApiValue(specialtyDataFields.specialtyDataValue),
      in_provider_mstr_key: getApiValue(positionDataFields.positionDataValue),
      in_input_type: 1,
      ...(parsedRange.start && parsedRange.end
        ? {
            in_time_period_start_date: parsedRange.start,
            in_time_period_end_date: parsedRange.end,
          }
        : {}),
    };

    const providerArData = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: null,
      in_period_name: null,
      in_user_key: cookiesData.out_user_id,
    };

    try {
      const tableDataRes = await Action.GetProviderBaseTableData({
        in_user_key: cookiesData.out_user_id,
      });

      if (!tableDataRes) {
        console.warn("GetProviderBaseTableData returned false/invalid; continuing dashboard refresh.");
      }

      const tilesPromise = Action.getProviderDashboardCardData(providerapiParam).then((cardRes) => {
        setTiles(buildDashboardTiles(parseCardList(cardRes), history));
      });

      const chartsPromise = Promise.all([
        Action.getProviderStatusAndPlanData(providerapiParam),
        Action.getProviderSpeclityStatusAndPlanData(providerapiParam),
        Action.getPositionTypeData(providerapiParam),
        Action.GetProviderChartStatusSummary(providerapiParam),
        Action.getProviderChartRetention(providerapiParam),
        Action.getProviderChartAttritionData(providerapiParam),
        Action.GetProviderChartAgeVsExperience(providerapiParam),
        Action.getProviderChartTurnoverData(providerapiParam),
        Action.GetProviderChartARData(providerArData),
      ]);

      await tilesPromise;
      await chartsPromise;
    } catch (err) {
      console.error("Dashboard update failed:", err);
    } finally {
      setIsProviderStatusAndPlanDataLoading(false);
      setIsPositionDataLoading(false);
      setisspeclityProviderStatusAndPlanDataLoading(false);
      setProviderSummaryLoading(false);
      setProviderRetentionLoading(false);
      setAttritionChartLoading(false);
      setProviderAgeExperienceLoading(false);
      setTurnoverChartLoading(false);
      setProviderARChartLoading(false);
    }
  };

  const handleLegendItemClick = (e, seriesItem, datasetItemIdx) => {
    resetAllRefreshFlags();

    setSeries((prevSeries) => {
      const visibleCount = prevSeries.filter((item) => item.visible !== false).length;
      const target = prevSeries[datasetItemIdx];
      const isCurrentlyVisible = target.visible !== false;
      if (isCurrentlyVisible && visibleCount === 1) {
        return prevSeries;
      }
      return prevSeries.map((item, index) => {
        if (index === datasetItemIdx) {
          return { ...item, visible: !isCurrentlyVisible };
        }
        return item;
      });
    });

    pulseRefresh(setRefreshChart);
  };

  const handleLegendItemClickForSpeclityChart = (e, seriesItem, datasetItemIdx) => {
    resetAllRefreshFlags();

    setspeclitySeries((prevSeries) => {
      const visibleCount = prevSeries.filter((s) => s.visible !== false).length;
      const target = prevSeries[datasetItemIdx];
      const isVisible = target.visible !== false;

      if (isVisible && visibleCount === 1) return prevSeries;

      return prevSeries.map((item, index) => (index === datasetItemIdx ? { ...item, visible: !isVisible } : item));
    });

    pulseRefresh(setRefreshCompSpecialtyProviderChart);
  };

  const handleLegendItemClickForDonutChart = (e, seriesItem, idx) => {
    resetAllRefreshFlags();

    setProviderDonutData((prevData) => {
      const isDefaultSeries = (seriesItem?.category || "").toString().toLowerCase() === "default";
      if (isDefaultSeries) {
        return prevData.map((item, index) => {
          if (index !== idx) return item;
          const originalValue = item.originalValue ?? item.value;
          const isRemoved = item.value === 0;
          return {
            ...item,
            originalValue,
            value: isRemoved ? originalValue : 0,
            visible: isRemoved ? 1 : 0,
          };
        });
      }

      const visibleCount = prevData.filter((item) => item.value !== 0).length;
      const target = prevData[idx];
      const isVisible = target.value !== 0;

      if (isVisible && visibleCount === 1) return prevData;

      return prevData.map((item, index) => {
        if (index === idx) {
          const originalValue = item.originalValue ?? item.value;
          const isRemoved = item.value === 0;
          return {
            ...item,
            originalValue,
            value: isRemoved ? originalValue : 0,
            visible: isRemoved ? 1 : 0,
          };
        }
        return item;
      });
    });

    pulseRefresh(setRefreshpositionTypeChart);
  };

  const handleLegendItemClickForTopSpecialtyProviderChart = (e, seriesItem, datasetItemIdx) => {
    setRefreshProviderChart(false);
    setRefreshpositionTypeChart(false);
    setRefreshCompSpecialtyProviderChart(false);
    setRefreshProviderSummaryChart(false);
    setRefreshProviderRetentionChart(false);
    setRefreshProviderAttritionChart(false);
    setRefreshProviderAgeExperienceChart(false);
    setRefreshChart(false);
    setRefreshProviderARChart(false);

    setRefreshProviderTurnoverChart(false);

    setSpecialtyPositionTypeSeries((prevSeries) => {
      const visibleCount = prevSeries.filter((item) => item.data.length > 0).length;
      const target = prevSeries[datasetItemIdx];
      const isVisible = target.data.length > 0;

      if (isVisible && visibleCount === 1) return prevSeries;

      return prevSeries.map((item, index) => {
        if (index === datasetItemIdx) {
          const originalData = item.originalData || item.data;
          const isRemoved = item.data.length === 0;
          return {
            ...item,
            originalData,
            data: isRemoved ? originalData : [],
            visible: isRemoved ? 1 : 0,
          };
        }
        return item;
      });
    });

    pulseRefresh(setRefreshSpecialtyProviderChart);
  };

  const handleLegendItemClickForTopProviderChart = (e, seriesItem, datasetItemIdx) => {
    setRefreshpositionTypeChart(false);
    setRefreshSpecialtyProviderChart(false);
    setRefreshCompSpecialtyProviderChart(false);
    setRefreshProviderSummaryChart(false);
    setRefreshProviderRetentionChart(false);
    setRefreshProviderAttritionChart(false);
    setRefreshProviderAgeExperienceChart(false);
    setRefreshChart(false);
    setRefreshProviderTurnoverChart(false);
    setRefreshProviderARChart(false);

    setGroupPositionTypeSeries((prevSeries) => {
      const visibleCount = prevSeries.filter((item) => item.data.length > 0).length;
      const target = prevSeries[datasetItemIdx];
      const isVisible = target.data.length > 0;

      if (isVisible && visibleCount === 1) return prevSeries;

      return prevSeries.map((item, index) => {
        if (index === datasetItemIdx) {
          const originalData = item.originalData || item.data;
          const isRemoved = item.data.length === 0;
          return {
            ...item,
            originalData,
            data: isRemoved ? originalData : [],
            visible: isRemoved ? 1 : 0,
          };
        }
        return item;
      });
    });

    pulseRefresh(setRefreshProviderChart);
  };

  const handleLegendItemClickForPositionSummaryChart = (e, seriesItem, datasetItemIdx) => {
    setRefreshpositionTypeChart(false);
    setRefreshSpecialtyProviderChart(false);
    setRefreshCompSpecialtyProviderChart(false);
    setRefreshProviderChart(false);
    setRefreshProviderRetentionChart(false);
    setRefreshProviderAttritionChart(false);
    setRefreshProviderAgeExperienceChart(false);
    setRefreshProviderARChart(false);

    setProviderSummaryData((prevSeries) => {
      const visibleCount = prevSeries.filter((item) => item.data.length > 0).length;
      const target = prevSeries[datasetItemIdx];
      const isVisible = target.data.length > 0;

      if (isVisible && visibleCount === 1) return prevSeries;

      return prevSeries.map((item, index) => {
        if (index === datasetItemIdx) {
          const originalData = item.originalData || item.data;
          const isRemoved = item.data.length === 0;
          return {
            ...item,
            originalData,
            data: isRemoved ? originalData : [],
            visible: isRemoved ? 1 : 0,
          };
        }
        return item;
      });
    });

    pulseRefresh(setRefreshProviderSummaryChart);
  };

  const handleLegendItemClickForPositionAttritionChart = (e, seriesItem, datasetItemIdx) => {
    setRefreshpositionTypeChart(false);
    setRefreshSpecialtyProviderChart(false);
    setRefreshCompSpecialtyProviderChart(false);
    setRefreshProviderChart(false);
    setRefreshProviderSummaryChart(false);
    setRefreshProviderRetentionChart(false);
    setRefreshProviderAgeExperienceChart(false);
    setRefreshChart(false);

    setRefreshProviderTurnoverChart(false);
    setRefreshProviderARChart(false);

    setAttritionSeries((prevSeries) => {
      const visibleCount = prevSeries.filter((item) => item.data.length > 0).length;
      const target = prevSeries[datasetItemIdx];
      const isVisible = target.data.length > 0;

      if (isVisible && visibleCount === 1) return prevSeries;

      return prevSeries.map((item, index) => {
        if (index === datasetItemIdx) {
          const originalData = item.originalData || item.data;
          const isRemoved = item.data.length === 0;
          return {
            ...item,
            originalData,
            data: isRemoved ? originalData : [],
            visible: isRemoved ? 1 : 0,
          };
        }
        return item;
      });
    });

    pulseRefresh(setRefreshProviderAttritionChart);
  };

  const handleLegendItemClickForPositionTurnOverChart = (e, seriesItem, datasetItemIdx) => {
    resetAllRefreshFlags();

    const clickedName = seriesItem.name;

    setTurnoverSeries((prevSeries) => {
      const visibleCount = prevSeries.filter((item) => item.data.length > 0).length;
      const target = prevSeries.find((s) => s.name === clickedName);
      const isVisible = target.data.length > 0;

      if (isVisible && visibleCount === 1) return prevSeries;

      return prevSeries.map((item) => {
        if (item.name === clickedName) {
          const originalData = item.originalData || item.data;
          const isRemoved = item.data.length === 0;

          return {
            ...item,
            originalData,
            data: isRemoved ? originalData : [],
            visible: isRemoved ? 1 : 0,
          };
        }
        return item;
      });
    });

    pulseRefresh(setRefreshProviderTurnoverChart);
  };

  const sortedTurnoverSeries = React.useMemo(() => {
    return [...turnoverSeries].sort((a, b) => {
      const aName = a.name.toLowerCase();
      const bName = b.name.toLowerCase();

      const aIsTurnover = aName.includes("turnover");
      const bIsTurnover = bName.includes("turnover");

      if (aIsTurnover && !bIsTurnover) return 1;
      if (!aIsTurnover && bIsTurnover) return -1;

      const getYearsValue = (name) => {
        if (name.startsWith("<")) return 0;
        if (name.includes("+")) return 20;
        return parseInt(name, 10);
      };

      const aVal = getYearsValue(a.name);
      const bVal = getYearsValue(b.name);

      return bVal - aVal;
    });
  }, [turnoverSeries]);
  const getAdaptiveIntegerAxisConfig = (inputValues) => {
    const numericValues = (inputValues || []).map((v) => Number(v)).filter((v) => Number.isFinite(v));
    if (!numericValues.length) {
      return {
        min: undefined,
        max: undefined,
        majorUnit: undefined,
      };
    }

    const rawMin = Math.min(...numericValues);
    const rawMax = Math.max(...numericValues);

    if (rawMax < 50) {
      return {
        min: 0,
        max: 60,
        majorUnit: 10,
      };
    }

    const range = Math.max(1, rawMax - rawMin);
    const roughStep = Math.max(1, Math.ceil(range / 6));
    const magnitude = Math.pow(10, Math.floor(Math.log10(roughStep)));
    const normalized = roughStep / magnitude;
    const stepBase = normalized <= 1 ? 1 : normalized <= 2 ? 2 : normalized <= 5 ? 5 : 10;
    const majorUnit = stepBase * magnitude;

    const min = Math.floor(rawMin / majorUnit) * majorUnit;
    const baseMax = Math.max(min + majorUnit, Math.ceil(rawMax / majorUnit) * majorUnit);
    const max = baseMax + majorUnit;

    return { min, max, majorUnit };
  };

  const providerChartAxisConfig = React.useMemo(() => {
    const visibleSeries = (series || []).filter((s) => s.visible !== false);
    const visibleValues = visibleSeries.flatMap((s) => (Array.isArray(s.data) ? s.data : []));
    return getAdaptiveIntegerAxisConfig(visibleValues);
  }, [series]);

  const getSpecialtyStackedAxisConfig = (chartSeries) => {
    const visibleSeries = (chartSeries || []).filter((s) => s.visible !== false);
    const numCategories = Math.max(0, ...visibleSeries.map((s) => (Array.isArray(s.data) ? s.data.length : 0)));
    if (numCategories === 0) {
      return { min: undefined, max: undefined, majorUnit: undefined };
    }

    const stackTotals = [];
    for (let i = 0; i < numCategories; i++) {
      let sum = 0;
      for (const s of visibleSeries) {
        const arr = Array.isArray(s.data) ? s.data : [];
        sum += Number(arr[i]) || 0;
      }
      stackTotals.push(sum);
    }

    const maxValue = Math.max(...stackTotals, 0);
    if (maxValue < 50) {
      return { min: 0, max: 60, majorUnit: 10 };
    }

    const range = Math.max(1, maxValue);
    const roughStep = Math.max(1, Math.ceil(range / 8));
    const magnitude = Math.pow(10, Math.floor(Math.log10(roughStep)));
    const normalized = roughStep / magnitude;
    const stepBase = normalized <= 1 ? 1 : normalized <= 2 ? 2 : normalized <= 5 ? 5 : 10;
    const majorUnit = stepBase * magnitude;
    const axisMax = Math.ceil(maxValue / majorUnit) * majorUnit + majorUnit;

    return {
      min: 0,
      max: axisMax,
      majorUnit,
    };
  };
  const specialtyChartPreparedState = React.useMemo(() => {
    const rawCategories = speclityCategories || [];
    const rawSeries = speclitySeries || [];
    const excludedCategory = specialtyChartOutlierState.excludedCategory;

    if (rawCategories.length === 0) {
      return {
        categories: rawCategories,
        series: rawSeries,
        axisConfig: getSpecialtyStackedAxisConfig(rawSeries),
        excludedCategory: null,
      };
    }

    if (!excludedCategory || !isSpecialtyOutlierFilterEnabled) {
      return {
        categories: rawCategories,
        series: rawSeries,
        axisConfig: getSpecialtyStackedAxisConfig(rawSeries),
        excludedCategory: null,
      };
    }

    const excludedIndex = excludedCategory.index;
    const filteredCategories = rawCategories.filter((_, index) => index !== excludedIndex);
    const filteredSeries = rawSeries.map((seriesItem) => ({
      ...seriesItem,
      data: (Array.isArray(seriesItem.data) ? seriesItem.data : []).filter((_, index) => index !== excludedIndex),
    }));

    return {
      categories: filteredCategories,
      series: filteredSeries,
      axisConfig: getSpecialtyStackedAxisConfig(filteredSeries),
      excludedCategory,
    };
  }, [
    speclityCategories,
    speclitySeries,
    specialtyChartOutlierState.excludedCategory,
    isSpecialtyOutlierFilterEnabled,
  ]);

  const handleLegendItemClickForPositionRetentionChart = (e, seriesItem, datasetItemIdx) => {
    resetAllRefreshFlags();

    setGroupedData((prevSeries) => {
      const visibleCount = prevSeries.filter((item) => item.data.length > 0).length;
      const target = prevSeries[datasetItemIdx];
      const isVisible = target.data.length > 0;

      if (isVisible && visibleCount === 1) return prevSeries;

      return prevSeries.map((item, index) => {
        if (index === datasetItemIdx) {
          const originalData = item.originalData || item.data;
          const isRemoved = item.data.length === 0;
          return {
            ...item,
            originalData,
            data: isRemoved ? originalData : [],
            visible: isRemoved ? 1 : 0,
          };
        }
        return item;
      });
    });
  };

  const renderTooltip = (context) => {
    const { category, series, value } = context.point || context;

    return (
      <div>
        {`${category || ""} ${series?.name || ""}`} : {value}
      </div>
    );
  };

  const renderProviderCountTooltip = (context) => {
    const { series, value } = context.point || context;

    return (
      <div>
        {series?.name || ""} : {value}
      </div>
    );
  };

  const handleSeriesClick = (e) => {
    if (e?.nativeEvent?.button === 2) {
      e.preventDefault();
      return;
    }
    let providerPlanItem = "providerPlanItem";
    let dateValue = "Effective Date - Current";
    if (e.series.name === "Terminated") {
      dateValue = "Terminated Date - Current";
    } else if (e.series.name === "New Hire") {
      dateValue = "Hire Date - Current";
    }
    const dataObj = {
      name: providerPlanItem,
      value: e.category,
      dateValue: dateValue,
      seriesName: e.series?.name ?? null,
    };
    history.push("/prv_pos", { providerPlanItem: dataObj });
  };
  const handleSeriesClickForSpeclityChart = (e) => {
    if (e?.nativeEvent?.button === 2) {
      e.preventDefault();
      return;
    }
    if (e?.nativeEvent?.button === 2) {
      e.preventDefault();
      return;
    }
    let providerSpeclityPlanItem = "providerSpeclityPlanItem";

    const dataObj = {
      name: providerSpeclityPlanItem,
      speciality: e.category,
      plan: e.series.name,
    };
    history.push("/prv_pos", { providerSpeclityPlanItem: dataObj });
  };

  const handleSeriesClickForSpecialtyDonutChart = (e) => {
    if (e?.nativeEvent?.button === 2) {
      e.preventDefault();
      return;
    }
    let providerSpecialtyItem = "providerSpecialtyItem";

    const dataObj = {
      name: providerSpecialtyItem,
      speciality: e.category,
    };
    history.push("/prv_pos", { providerSpecialtyItem: dataObj });
  };

  const handleLegendItemClickForProviderArCount = (e, seriesItem, datasetItemIdx) => {
    resetAllRefreshFlags();

    const clickedName = seriesItem.name;

    setProviderARSeries((prevSeries) => {
      const visibleCount = prevSeries.filter((item) => item.data.length > 0).length;
      const target = prevSeries.find((s) => s.name === clickedName);
      const isVisible = target.data.length > 0;

      if (isVisible && visibleCount === 1) return prevSeries;

      return prevSeries.map((item) => {
        if (item.name === clickedName) {
          const originalData = item.originalData || item.data;
          const isRemoved = item.data.length === 0;

          return {
            ...item,
            originalData,
            data: isRemoved ? originalData : [],
            visible: isRemoved ? 1 : 0,
          };
        }
        return item;
      });
    });
    pulseRefresh(setRefreshProviderARChart);
  };

  const handleProviderChartNavigateLeft = (isExpanded) => {
    if (isExpanded) {
      providerChartNavExpanded.navigateLeft();
    } else {
      providerChartNav.navigateLeft();
    }
    setRefreshProviderChart(true);
    setRefreshCompSpecialtyProviderChart(false);

    setTimeout(() => setRefreshProviderChart(false), 100);
  };

  const handleProviderChartNavigateRight = (isExpanded) => {
    if (isExpanded) {
      providerChartNavExpanded.navigateRight();
    } else {
      providerChartNav.navigateRight();
    }
    setRefreshProviderChart(true);
    setRefreshCompSpecialtyProviderChart(false);

    setTimeout(() => setRefreshProviderChart(false), 100);
  };

  const handleProviderChartReset = (isExpanded) => {
    if (isExpanded) {
      providerChartNavExpanded.resetRange();
    } else {
      providerChartNav.resetRange();
    }
    setRefreshProviderChart(true);
    setRefreshCompSpecialtyProviderChart(false);

    setTimeout(() => setRefreshProviderChart(false), 100);
  };

  const handleSpecialtyChartNavigateLeft = (isExpanded) => {
    if (isExpanded) {
      specialtyChartNavExpanded.navigateLeft();
    } else {
      specialtyChartNav.navigateLeft();
    }
    setRefreshChart(false);
    setRefreshCompSpecialtyProviderChart(true);
    setTimeout(() => setRefreshCompSpecialtyProviderChart(false), 100);
  };

  const handleSpecialtyChartNavigateRight = (isExpanded) => {
    if (isExpanded) {
      specialtyChartNavExpanded.navigateRight();
    } else {
      specialtyChartNav.navigateRight();
    }
    setRefreshChart(false);
    setRefreshCompSpecialtyProviderChart(true);
    setTimeout(() => setRefreshCompSpecialtyProviderChart(false), 100);
  };

  const handleSpecialtyChartReset = (isExpanded) => {
    if (isExpanded) {
      specialtyChartNavExpanded.resetRange();
    } else {
      specialtyChartNav.resetRange();
    }
    setRefreshChart(false);
    setRefreshCompSpecialtyProviderChart(true);
    setTimeout(() => setRefreshCompSpecialtyProviderChart(false), 100);
  };
  React.useEffect(() => {
    specialtyChartNav.resetRange();
    specialtyChartNavExpanded.resetRange();
    setRefreshCompSpecialtyProviderChart(true);
    const timer = setTimeout(() => setRefreshCompSpecialtyProviderChart(false), 100);
    return () => clearTimeout(timer);
  }, [isSpecialtyOutlierFilterEnabled]);

  const handleTurnoverChartNavigateLeft = (isExpanded) => {
    if (isExpanded) {
      turnoverChartNavExpanded.navigateLeft();
    } else {
      turnoverChartNav.navigateLeft();
    }
    setRefreshProviderTurnoverChart(true);
    setTimeout(() => setRefreshProviderTurnoverChart(false), 100);
  };

  const handleTurnoverChartNavigateRight = (isExpanded) => {
    if (isExpanded) {
      turnoverChartNavExpanded.navigateRight();
    } else {
      turnoverChartNav.navigateRight();
    }
    setRefreshProviderTurnoverChart(true);
    setTimeout(() => setRefreshProviderTurnoverChart(false), 100);
  };

  const handleTurnoverChartReset = (isExpanded) => {
    if (isExpanded) {
      turnoverChartNavExpanded.resetRange();
    } else {
      turnoverChartNav.resetRange();
    }
    setRefreshProviderTurnoverChart(true);
    setTimeout(() => setRefreshProviderTurnoverChart(false), 100);
  };

  const handleProviderCountChartNavigateLeft = (isExpanded) => {
    if (isExpanded) {
      providerCountChartNavExpanded.navigateLeft();
    } else {
      providerCountChartNav.navigateLeft();
    }
    setRefreshProviderARChart(true);
    setTimeout(() => setRefreshProviderARChart(false), 100);
  };

  const handleProviderCountChartNavigateRight = (isExpanded) => {
    if (isExpanded) {
      providerCountChartNavExpanded.navigateRight();
    } else {
      providerCountChartNav.navigateRight();
    }
    setRefreshProviderARChart(true);
    setTimeout(() => setRefreshProviderARChart(false), 100);
  };

  const handleProviderCountChartReset = (isExpanded) => {
    if (isExpanded) {
      providerCountChartNavExpanded.resetRange();
    } else {
      providerCountChartNav.resetRange();
    }
    setRefreshProviderARChart(true);
    setTimeout(() => setRefreshProviderARChart(false), 100);
  };

  const handleAgeAnalysisMainChartNavigateLeft = (isExpanded) => {
    if (isExpanded) {
      ageAnalysisMainChartNavExpanded.navigateLeft();
    } else {
      ageAnalysisMainChartNav.navigateLeft();
    }
    setRefreshProviderAgeExperienceChart(true);
    setTimeout(() => setRefreshProviderAgeExperienceChart(false), 100);
  };

  const handleAgeAnalysisMainChartNavigateRight = (isExpanded) => {
    if (isExpanded) {
      ageAnalysisMainChartNavExpanded.navigateRight();
    } else {
      ageAnalysisMainChartNav.navigateRight();
    }
    setRefreshProviderAgeExperienceChart(true);
    setTimeout(() => setRefreshProviderAgeExperienceChart(false), 100);
  };

  const handleAgeAnalysisMainChartReset = (isExpanded) => {
    if (isExpanded) {
      ageAnalysisMainChartNavExpanded.resetRange();
    } else {
      ageAnalysisMainChartNav.resetRange();
    }
    setRefreshProviderAgeExperienceChart(true);
    setTimeout(() => setRefreshProviderAgeExperienceChart(false), 100);
  };

  const handleAgeAnalysisDrilldownChartNavigateLeft = (isExpanded) => {
    if (isExpanded) {
      ageAnalysisDrilldownChartNavExpanded.navigateLeft();
    } else {
      ageAnalysisDrilldownChartNav.navigateLeft();
    }
    setRefreshProviderAgeExperienceChart(true);
    setTimeout(() => setRefreshProviderAgeExperienceChart(false), 100);
  };

  const handleAgeAnalysisDrilldownChartNavigateRight = (isExpanded) => {
    if (isExpanded) {
      ageAnalysisDrilldownChartNavExpanded.navigateRight();
    } else {
      ageAnalysisDrilldownChartNav.navigateRight();
    }
    setRefreshProviderAgeExperienceChart(true);
    setTimeout(() => setRefreshProviderAgeExperienceChart(false), 100);
  };

  const handleAgeAnalysisDrilldownChartReset = (isExpanded) => {
    if (isExpanded) {
      ageAnalysisDrilldownChartNavExpanded.resetRange();
      ageAnalysisDrilldownChartYAxisNavExpanded.resetRange();
    } else {
      ageAnalysisDrilldownChartNav.resetRange();
      ageAnalysisDrilldownChartYAxisNav.resetRange();
    }
    setRefreshProviderAgeExperienceChart(true);
    setTimeout(() => setRefreshProviderAgeExperienceChart(false), 100);
  };

  const handleAgeAnalysisDrilldownChartNavigateUp = (isExpanded) => {
    if (isExpanded) {
      ageAnalysisDrilldownChartYAxisNavExpanded.navigateUp();
    } else {
      ageAnalysisDrilldownChartYAxisNav.navigateUp();
    }
    setRefreshProviderAgeExperienceChart(true);
    setTimeout(() => setRefreshProviderAgeExperienceChart(false), 100);
  };

  const handleAgeAnalysisDrilldownChartNavigateDown = (isExpanded) => {
    if (isExpanded) {
      ageAnalysisDrilldownChartYAxisNavExpanded.navigateDown();
    } else {
      ageAnalysisDrilldownChartYAxisNav.navigateDown();
    }
    setRefreshProviderAgeExperienceChart(true);
    setTimeout(() => setRefreshProviderAgeExperienceChart(false), 100);
  };

  const renderProviderChart = (isExpanded, handleDragStart) => {
    return !isProviderStatusAndPlanDataLoading ? (
      <>
        {!isExpanded ? (
          <h5 class="chart-title">
            <div className="charttitle-left">
              <DropDownList
                data={POSITION_PROVIDER_DROPDOWN}
                textField="text"
                dataItemKey="value"
                className="providerstatusplan-dropdown chartcolumn-selection"
                value={providerPositionValue}
                onChange={handleProviderPositionValueDropdwon}
              />
              Status By Compensation Plan
              <Tooltip
                title={" Displays the distribution of provider statuses across compensation plans."}
                anchorElement="target"
                position="bottom"
                openDelay={100}
              >
                <i
                  class="fas fa-info-circle"
                  title={" Displays the distribution of provider statuses across compensation plans."}
                ></i>
              </Tooltip>
            </div>
            <div className="infoIcon-right">
              <DropDownList
                data={ALL_LAYOUT_OPTIONS}
                textField="text"
                dataItemKey="value"
                className="providerstatusplan-dropdown chartcolumn-selection"
                value={providerCharts.providerChartFields}
                onChange={handleProviderPositionChart}
              />

              <Button
                title="Expand Chart"
                togglable
                svgIcon={toggleFullScreenModeIcon}
                onClick={() => {
                  setIsWindowOpen(true);
                  setRefreshProviderChart(false);
                  setRefreshpositionTypeChart(false);
                  setRefreshSpecialtyProviderChart(false);
                  setRefreshChart(false);
                  setRefreshCompSpecialtyProviderChart(false);
                }}
                className="expandchartBtn"
              />

              <span className="drag-handle" draggable={true} onDragStart={handleDragStart} title="Drag this chart">
                <i class="fas fa-arrows-alt"></i>
              </span>
            </div>
          </h5>
        ) : (
          false
        )}
        {series.length > 0 && categories.length > 0 ? (
          <div className="innersection" style={{ position: "relative" }}>
            <div className="chart-legend-set">
              {series.map((s, idx) => {
                const seriesName = s.name;
                return (
                  <span
                    className="chart-legend-item"
                    key={idx}
                    style={{
                      color: s.color,
                      opacity: s.visible ? 1 : 0.5,
                    }}
                    onClick={(e) => handleLegendItemClick(e, s, idx)}
                  >
                    <span>{seriesName}</span>
                  </span>
                );
              })}
            </div>

            <ChartNavigation
              min={!isExpanded ? providerChartNav.range.min : providerChartNavExpanded.range.min}
              max={!isExpanded ? providerChartNav.range.max : providerChartNavExpanded.range.max}
              totalItems={categories.length}
              onNavigateLeft={() => handleProviderChartNavigateLeft(isExpanded)}
              onNavigateRight={() => handleProviderChartNavigateRight(isExpanded)}
              onReset={() => handleProviderChartReset(isExpanded)}
            />

            <Chart
              key={`provider-chart-${!isExpanded ? providerChartNav.range.min : providerChartNavExpanded.range.min}-${!isExpanded ? providerChartNav.range.max : providerChartNavExpanded.range.max}`}
              onRefresh={(chartOptions, themeOptions, chartInstance) => {
                if (refreshChart || refreshProviderChart) {
                  chartInstance.setOptions(chartOptions, themeOptions);
                }
              }}
              onSeriesClick={handleSeriesClick}
              style={{
                height: isExpanded ? `${window.innerHeight - 200}px` : null,
              }}
              pannable={false}
              zoomable={false}
              panAndZoom={{
                navigationLeft: (props) => (
                  <button {...props} style={{ color: "red" }}>
                    Go Left
                  </button>
                ),
                navigationRight: (props) => <button {...props}>Go Right</button>,

                navigation: {
                  visible: true,
                  position: "both",
                },
              }}
            >
              <ChartLegend visible={false} />
              <ChartTooltip render={renderTooltip} />

              <ChartCategoryAxis>
                <ChartCategoryAxisItem
                  categories={categories}
                  min={!isExpanded ? providerChartNav.range.min : providerChartNavExpanded.range.min}
                  max={!isExpanded ? providerChartNav.range.max : providerChartNavExpanded.range.max}
                  labels={{
                    rotation: -45,
                    font: "14px/1.1 Poppins, sans-serif",
                    content: (e) => convertLabelToMultiLine(e.value),
                  }}
                  title={{
                    text: "Compensation Plans",
                    font: "bold 9px",
                    color: "#007eff",
                  }}
                />
              </ChartCategoryAxis>

              <ChartValueAxis>
                <ChartValueAxisItem
                  min={providerChartAxisConfig.min}
                  max={providerChartAxisConfig.max}
                  majorUnit={providerChartAxisConfig.majorUnit}
                  labels={{ font: "12px", content: (e) => `${Math.round(Number(e.value) || 0)}` }}
                  title={{
                    text: providerPositionValue?.value === 1 ? "Providers" : "Positions",
                    font: "bold 20px",
                    color: "#007eff",
                  }}
                />
              </ChartValueAxis>

              <ChartSeries>
                {series
                  .filter((s) => s.visible !== false)
                  .map((s, idx) => (
                    <ChartSeriesItem key={idx} type="column" data={s.data} name={s.name} color={s.color} />
                  ))}
              </ChartSeries>
            </Chart>
          </div>
        ) : (
          <div className="innersection">
            <div className="nodata-overlay" style={{ height: "400px", backgroundColor: "white" }}>
              <h3>No Data Found</h3>
            </div>
          </div>
        )}
      </>
    ) : (
      loadingPanel
    );
  };

  const convertLabelToMultiLine = (label) => {
    if (!label || typeof label !== "string") {
      return label;
    }

    const text = label.trim();
    const len = text.length;

    if (len <= 15) {
      return text;
    }

    if (!text.includes(" ")) {
      const breakpoint = Math.floor(text.length / 2);
      return text.slice(0, breakpoint) + "-\n" + text.slice(breakpoint);
    }

    const splitByTarget = (str, target) => {
      const words = str.split(" ");
      let line1 = "";
      let line2 = "";

      for (let i = 0; i < words.length; i++) {
        const word = words[i];
        const tentative = (line1 ? line1 + " " : "") + word;

        if (tentative.length <= target || !line1) {
          line1 = tentative;
        } else {
          line2 = words.slice(i).join(" ");
          break;
        }
      }

      if (!line2 && str.length > target) {
        line1 = str.slice(0, target);
        line2 = str.slice(target);
      }

      return line2 ? `${line1}\n${line2.trim()}` : line1;
    };

    if (len > 30) {
      const firstLineTarget = Math.ceil(len * 0.5);
      return splitByTarget(text, firstLineTarget);
    }

    return splitByTarget(text, 15);
  };

  const renderProviderSpecialtyChart = (isExpanded, handleDragStart) => {
    {
      return !isspeclityProviderStatusAndPlanDataLoading ? (
        <>
          {!isExpanded ? (
            <h5 class="chart-title">
              <div className="charttitle-left">
                <DropDownList
                  data={POSITION_PROVIDER_DROPDOWN}
                  textField="text"
                  dataItemKey="value"
                  className="providerstatusplan-dropdown chartcolumn-selection"
                  value={providerPositionValueSpeclity}
                  onChange={handleProviderPositionValueDropdwonSpeclity}
                />{" "}
                By Specialty & Compensation Plan
                <Tooltip anchorElement="target" position="bottom" openDelay={100}>
                  <i
                    class="fas fa-info-circle"
                    title={" Displays the distribution of provider statuses across compensation plans and specialties."}
                  ></i>
                </Tooltip>
              </div>
              <div className="infoIcon-right">
                <DropDownList
                  data={ALL_LAYOUT_OPTIONS}
                  textField="text"
                  dataItemKey="value"
                  className="providerstatusplan-dropdown"
                  value={providerSpecialtyCharts.providerSpChartFields}
                  onChange={handleSpProviderPositionChart}
                  className="providerstatusplan-dropdown"
                />

                <Button
                  title="Expand Chart"
                  togglable
                  svgIcon={toggleFullScreenModeIcon}
                  onClick={() => {
                    setIsWindowOpenForProviderandSpecialtyChart(true);
                    setRefreshProviderChart(false);
                    setRefreshpositionTypeChart(false);
                    setRefreshSpecialtyProviderChart(false);
                    setRefreshChart(false);
                    setRefreshCompSpecialtyProviderChart(false);
                  }}
                  className="expandchartBtn"
                />

                <span className="drag-handle" draggable={true} onDragStart={handleDragStart} title="Drag this chart">
                  <i class="fas fa-arrows-alt"></i>
                </span>
              </div>
            </h5>
          ) : (
            false
          )}
          {specialtyChartPreparedState.series.length > 0 && specialtyChartPreparedState.categories.length > 0 ? (
            <div className="innersection" style={{ position: "relative" }}>
              <div className="chart-legend-set">
                {speclitySeries.map((s, idx) => {
                  const seriesName = s.name;
                  return (
                    <span
                      className="chart-legend-item"
                      key={idx}
                      style={{
                        color: s.color,
                        opacity: s.visible ? 1 : 0.5,
                      }}
                      onClick={(e) => handleLegendItemClickForSpeclityChart(e, s, idx)}
                    >
                      <span>{seriesName}</span>
                    </span>
                  );
                })}
              </div>
              {specialtyChartOutlierState.excludedCategory ? (
                <div
                  style={{
                    color: "#6b7280",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    marginTop: "8px",
                    marginBottom: "8px",
                  }}
                >
                  <Checkbox
                    checked={isSpecialtyOutlierFilterEnabled}
                    onChange={() => setIsSpecialtyOutlierFilterEnabled((prev) => !prev)}
                  />
                  <span>Excluding Default Specialty</span>
                </div>
              ) : null}

              <ChartNavigation
                min={!isExpanded ? specialtyChartNav.range.min : specialtyChartNavExpanded.range.min}
                max={!isExpanded ? specialtyChartNav.range.max : specialtyChartNavExpanded.range.max}
                totalItems={specialtyChartPreparedState.categories.length}
                onNavigateLeft={() => handleSpecialtyChartNavigateLeft(isExpanded)}
                onNavigateRight={() => handleSpecialtyChartNavigateRight(isExpanded)}
                onReset={() => handleSpecialtyChartReset(isExpanded)}
              />

              <Chart
                key={`specialty-chart-${!isExpanded ? specialtyChartNav.range.min : specialtyChartNavExpanded.range.min}-${!isExpanded ? specialtyChartNav.range.max : specialtyChartNavExpanded.range.max}-${isSpecialtyOutlierFilterEnabled ? "hide-default" : "show-default"}-${specialtyChartPreparedState.categories.length}`}
                onRefresh={(chartOptions, themeOptions, chartInstance) => {
                  if (refreshCompSpecialtyProviderChart) {
                    chartInstance.setOptions(chartOptions, themeOptions);
                  }
                }}
                onSeriesClick={handleSeriesClickForSpeclityChart}
                style={{
                  height: isExpanded ? `${window.innerHeight - 200}px` : null,
                }}
                pannable={false}
                zoomable={false}
              >
                <ChartTitle className="positiontypecharttitle" />
                <ChartLegend visible={false} />
                <ChartTooltip render={renderTooltip} />

                <ChartCategoryAxis>
                  <ChartCategoryAxisItem
                    categories={specialtyChartPreparedState.categories}
                    min={!isExpanded ? specialtyChartNav.range.min : specialtyChartNavExpanded.range.min}
                    max={!isExpanded ? specialtyChartNav.range.max : specialtyChartNavExpanded.range.max}
                    labels={{
                      rotation: -45,
                      font: "14px/1.1 Poppins, sans-serif",
                      content: (e) => convertLabelToMultiLine(e.value),
                    }}
                    title={{
                      text: "Specialties",
                      font: "bold 14px",
                      color: "#007eff",
                    }}
                  />
                </ChartCategoryAxis>

                <ChartValueAxis>
                  <ChartValueAxisItem
                    min={specialtyChartPreparedState.axisConfig.min}
                    max={specialtyChartPreparedState.axisConfig.max}
                    majorUnit={specialtyChartPreparedState.axisConfig.majorUnit}
                    labels={{ font: "12px ", content: (e) => `${Math.round(Number(e.value) || 0)}` }}
                    title={{
                      text: providerPositionValueSpeclity?.value === 1 ? "Providers" : "Positions",

                      font: "bold 14px",
                      color: "#007eff",
                    }}
                  />
                </ChartValueAxis>

                <ChartSeries>
                  {specialtyChartPreparedState.series
                    .filter((s) => s.visible !== false)
                    .map((s, idx) => (
                      <ChartSeriesItem
                        key={idx}
                        type="column"
                        data={s.data}
                        name={s.name}
                        color={s.color}
                        stack={true}
                      />
                    ))}
                </ChartSeries>
              </Chart>
            </div>
          ) : (
            <div className="innersection">
              <div className="nodata-overlay" style={{ height: "400px", backgroundColor: "white" }}>
                <h3>No Data Found</h3>
              </div>
            </div>
          )}
        </>
      ) : (
        loadingPanel
      );
    }
  };

  const renderProviderStatusBySpecialtyChart = (isExpanded, handleDragStart) => {
    {
      return !isPositionDataLoading ? (
        <>
          {!isExpanded ? (
            <h5 class="chart-title">
              <div className="charttitle-left">
                Active Providers by Specialty
                <Tooltip anchorElement="target" position="bottom" openDelay={100}>
                  <i
                    class="fas fa-info-circle"
                    title={" Displays the distribution of active provider statuses by specialties."}
                  ></i>
                </Tooltip>
              </div>
              <div className="infoIcon-right">
                <DropDownList
                  data={ALL_LAYOUT_OPTIONS}
                  textField="text"
                  dataItemKey="value"
                  className="providerstatusplan-dropdown chartcolumn-selection"
                  value={activeProviderCharts.providerActiveChartFields}
                  onChange={handleActiveProviderChart}
                  className="chartcolumn-selection"
                />

                <Button
                  title="Expand Chart"
                  togglable
                  svgIcon={toggleFullScreenModeIcon}
                  onClick={() => {
                    setIsWindowOpenForProviderandSpecialtyChartByStatus(true);
                    setRefreshProviderChart(false);
                    setRefreshSpecialtyProviderChart(false);
                    setRefreshChart(false);
                    setRefreshCompSpecialtyProviderChart(false);
                  }}
                  className="expandchartBtn"
                />

                <span className="drag-handle" draggable={true} onDragStart={handleDragStart} title="Drag this chart">
                  <i class="fas fa-arrows-alt"></i>
                </span>
              </div>
            </h5>
          ) : (
            false
          )}
          {providerDonutData.length > 0 ? (
            <div className="innersection">
              <div className="chart-legend-set">
                {providerDonutData.map((item, idx) => {
                  return (
                    <span
                      className="chart-legend-item"
                      key={idx}
                      style={{
                        color: item.color,
                        opacity: item.visible ? 1 : 0.5,
                      }}
                      onClick={(e) => handleLegendItemClickForDonutChart(e, item, idx)}
                    >
                      <span>{item.category}</span>
                    </span>
                  );
                })}
              </div>
              <Chart
                onRefresh={(chartOptions, themeOptions, chartInstance) => {
                  if (refreshpositionTypeChart) {
                    chartInstance.setOptions(chartOptions, themeOptions);
                  }
                }}
                style={{
                  height: isExpanded ? `${window.innerHeight - 200}px` : null,
                }}
                onSeriesClick={handleSeriesClickForSpecialtyDonutChart}
              >
                <ChartTitle text="Specialties" position="bottom" font="bold 14px" color="#007eff" />
                <ChartLegend visible={false} />
                <ChartTooltip
                  render={(e) => (
                    <div>
                      {e.point?.category}
                      <br />
                      Providers: {e.point?.value}
                    </div>
                  )}
                />

                <ChartSeries>
                  <ChartSeriesItem
                    type="donut"
                    data={providerDonutData}
                    categoryField="category"
                    field="value"
                    colorField="color"
                    nameField="name"
                  />
                </ChartSeries>
              </Chart>
            </div>
          ) : (
            <div className="innersection">
              <div className="nodata-overlay" style={{ height: "400px", backgroundColor: "white" }}>
                <h3>No Data Found</h3>
              </div>
            </div>
          )}
        </>
      ) : (
        loadingPanel
      );
    }
  };

  const renderProviderTrendChart = (isExpanded, handleDragStart) => {
    {
      return !providerSummaryLoading ? (
        <>
          <h5 class="chart-title">
            <div className="charttitle-left">
              Provider Trend Chart
              <Tooltip title="Provider Trend Chart" anchorElement="target" position="bottom" openDelay={100}>
                <svg
                  fill="#989898"
                  width="20px"
                  height="20px"
                  viewBox="0 0 1920 1920"
                  xmlns="http://www.w3.org/2000/svg"
                  title={"Provider Trend Chart"}
                >
                  <path
                    d="M960 0c530.193 0 960 429.807 960 960s-429.807 960-960 960S0 1490.193 0 960 429.807 0 960 0Zm0 101.053c-474.384 0-858.947 384.563-858.947 858.947S485.616 1818.947 960 1818.947 1818.947 1434.384 1818.947 960 1434.384 101.053 960 101.053Zm-42.074 626.795c-85.075 39.632-157.432 107.975-229.844 207.898-10.327 14.249-10.744 22.907-.135 30.565 7.458 5.384 11.792 3.662 22.656-7.928 1.453-1.562 1.453-1.562 2.94-3.174 9.391-10.17 16.956-18.8 33.115-37.565 53.392-62.005 79.472-87.526 120.003-110.867 35.075-20.198 65.9 9.485 60.03 47.471-1.647 10.664-4.483 18.534-11.791 35.432-2.907 6.722-4.133 9.646-5.496 13.23-13.173 34.63-24.269 63.518-47.519 123.85l-1.112 2.886c-7.03 18.242-7.03 18.242-14.053 36.48-30.45 79.138-48.927 127.666-67.991 178.988l-1.118 3.008a10180.575 10180.575 0 0 0-10.189 27.469c-21.844 59.238-34.337 97.729-43.838 138.668-1.484 6.37-1.484 6.37-2.988 12.845-5.353 23.158-8.218 38.081-9.82 53.42-2.77 26.522-.543 48.24 7.792 66.493 9.432 20.655 29.697 35.43 52.819 38.786 38.518 5.592 75.683 5.194 107.515-2.048 17.914-4.073 35.638-9.405 53.03-15.942 50.352-18.932 98.861-48.472 145.846-87.52 41.11-34.26 80.008-76 120.788-127.872 3.555-4.492 3.555-4.492 7.098-8.976 12.318-15.707 18.352-25.908 20.605-36.683 2.45-11.698-7.439-23.554-15.343-19.587-3.907 1.96-7.993 6.018-14.22 13.872-4.454 5.715-6.875 8.77-9.298 11.514-9.671 10.95-19.883 22.157-30.947 33.998-18.241 19.513-36.775 38.608-63.656 65.789-13.69 13.844-30.908 25.947-49.42 35.046-29.63 14.559-56.358-3.792-53.148-36.635 2.118-21.681 7.37-44.096 15.224-65.767 17.156-47.367 31.183-85.659 62.216-170.048 13.459-36.6 19.27-52.41 26.528-72.201 21.518-58.652 38.696-105.868 55.04-151.425 20.19-56.275 31.596-98.224 36.877-141.543 3.987-32.673-5.103-63.922-25.834-85.405-22.986-23.816-55.68-34.787-96.399-34.305-45.053.535-97.607 15.256-145.963 37.783Zm308.381-388.422c-80.963-31.5-178.114 22.616-194.382 108.33-11.795 62.124 11.412 115.76 58.78 138.225 93.898 44.531 206.587-26.823 206.592-130.826.005-57.855-24.705-97.718-70.99-115.729Z"
                    fill-rule="evenodd"
                  />
                </svg>
              </Tooltip>
            </div>
            <div className="infoIcon-right">
              <DropDownList
                data={CHART_LAYOUT_OPTIONS}
                textField="text"
                dataItemKey="value"
                className="providerstatusplan-dropdown chartcolumn-selection"
                value={providerTrendCharts.providerTrendChartFields}
                onChange={handleProviderTrendChart}
              />

              <Button
                title="Expand Chart"
                togglable
                svgIcon={toggleFullScreenModeIcon}
                onClick={() => setIsWindowOpenForProviderTrendChart(true)}
                className="expandchartBtn"
              />

              {!isExpanded ? (
                <span className="drag-handle" draggable={true} onDragStart={handleDragStart} title="Drag this chart">
                  <i class="fas fa-arrows-alt"></i>
                </span>
              ) : (
                false
              )}
            </div>
          </h5>
          <div className="innersection">
            <div className="chart-legend-set">
              {providerSummaryData.map((s, idx) => {
                const seriesName = s.name;
                return (
                  <span
                    className="chart-legend-item"
                    key={idx}
                    style={{
                      color: s.color,
                      opacity: s.visible ? 1 : 0.5,
                    }}
                    onClick={(e) => handleLegendItemClickForPositionSummaryChart(e, s, idx)}
                  >
                    <span>{seriesName}</span>
                  </span>
                );
              })}
            </div>
            <Chart
              onRefresh={(chartOptions, themeOptions, chartInstance) => {
                if (refreshProviderSummaryChart) {
                  chartInstance.setOptions(chartOptions, themeOptions);
                }
              }}
              style={{
                height: isExpanded ? `${window.innerHeight - 200}px` : null,
              }}
            >
              <ChartCategoryAxis>
                <ChartCategoryAxisItem
                  categories={providerSummaryCategories}
                  title={{ text: "Month" }}
                  labels={{
                    rotation: providerSummaryCategories.length > 3 ? -45 : 0,
                    font: "12px ",
                    margin: { top: 10 },
                  }}
                />
              </ChartCategoryAxis>
              <ChartValueAxis>
                <ChartValueAxisItem
                  labels={{ font: "12px" }}
                  title={{
                    text: "Providers",
                    font: "bold 20px",
                    color: "#007eff",
                  }}
                />
              </ChartValueAxis>
              <ChartTooltip render={renderTooltip} />
              <ChartLegend visible={false} />
              <ChartSeries>
                {providerSummaryData.map((series, idx) => (
                  <ChartSeriesItem
                    key={idx}
                    type="line"
                    markers={{ visible: true }}
                    name={series.name}
                    data={series.data}
                    color={providerSummaryColors[series.name]}
                  />
                ))}
              </ChartSeries>
            </Chart>
          </div>
        </>
      ) : (
        loadingPanel
      );
    }
  };
  const saveChartLayoutToAPI = async (labelName, layoutValue) => {
    const updateLayoutParams = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_user_id: cookiesData.out_user_id,
      label_name: labelName,
      layout_value: layoutValue,
      in_pod_order: null,
    };
    let updateRes = await Action.updateLayout(updateLayoutParams);
  };
  const saveChartLayoutOrderToApi = async (labelName, layoutValue) => {
    const updateLayoutParams = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_user_id: cookiesData.out_user_id,
      label_name: labelName,
      layout_value: null,
      in_pod_order: layoutValue,
    };
    let updateRes = await Action.updateLayout(updateLayoutParams);
  };

  const handleProviderPositionChart = async (e) => {
    setIsProviderStatusAndPlanDataLoading(true);

    setProviderCharts((prev) => ({
      ...prev,
      providerChartFields: e.value,
    }));

    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    await saveChartLayoutToAPI("provider_status_by_comp_plan", e.value.parse_value);

    timeout.current = setTimeout(() => {
      setIsProviderStatusAndPlanDataLoading(false);
      setLayoutVersion((prev) => prev + 1);
      resetAllRefreshFlags();
    }, 500);
  };
  const handleProviderPositionValueDropdwon = async (e) => {
    setRefreshCompSpecialtyProviderChart(false);

    setIsProviderStatusAndPlanDataLoading(true);
    setproviderPositionValue(e.value);

    const providerapiParam = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_user_key: cookiesData.out_user_id,
      in_org_title_key: null,
      in_specialty_mstr_key: null,
      in_provider_mstr_key: null,
      in_input_type: e.value.value,
    };

    Action.getProviderStatusAndPlanData(providerapiParam);
    timeout.current = setTimeout(() => {
      setRefreshChart(true);
    }, 500);
  };
  const handleProviderPositionValueDropdwonSpeclity = async (e) => {
    setRefreshChart(false);
    setRefreshProviderChart(false);
    setisspeclityProviderStatusAndPlanDataLoading(true);
    setproviderPositionValueSpeclity(e.value);

    const providerapiParam = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_user_key: cookiesData.out_user_id,
      in_org_title_key: null,
      in_specialty_mstr_key: null,
      in_provider_mstr_key: null,
      in_input_type: e.value.value,
    };

    Action.getProviderSpeclityStatusAndPlanData(providerapiParam);

    timeout.current = setTimeout(() => {
      setRefreshCompSpecialtyProviderChart(true);
    }, 500);
  };

  const renderProviderAttritionChart = (isExpanded, handleDragStart) => {
    return !attritionChartLoading ? (
      attritionCategories.length > 0 ? (
        <>
          <h5 className="chart-title">
            <div className="charttitle-left">
              Active Headcount and Attrition Rate%
              <Tooltip anchorElement="target" position="bottom" openDelay={100}>
                <svg
                  fill="#989898"
                  width="20px"
                  height="20px"
                  viewBox="0 0 1920 1920"
                  xmlns="http://www.w3.org/2000/svg"
                  title={"Active Headcount and Attrition Rate%"}
                >
                  <path
                    d="M960 0c530.193 0 960 429.807 960 960s-429.807 960-960 960S0 1490.193 0 960 429.807 0 960 0Zm0 101.053c-474.384 0-858.947 384.563-858.947 858.947S485.616 1818.947 960 1818.947 1818.947 1434.384 1818.947 960 1434.384 101.053 960 101.053Zm-42.074 626.795c-85.075 39.632-157.432 107.975-229.844 207.898-10.327 14.249-10.744 22.907-.135 30.565 7.458 5.384 11.792 3.662 22.656-7.928 1.453-1.562 1.453-1.562 2.94-3.174 9.391-10.17 16.956-18.8 33.115-37.565 53.392-62.005 79.472-87.526 120.003-110.867 35.075-20.198 65.9 9.485 60.03 47.471-1.647 10.664-4.483 18.534-11.791 35.432-2.907 6.722-4.133 9.646-5.496 13.23-13.173 34.63-24.269 63.518-47.519 123.85l-1.112 2.886c-7.03 18.242-7.03 18.242-14.053 36.48-30.45 79.138-48.927 127.666-67.991 178.988l-1.118 3.008a10180.575 10180.575 0 0 0-10.189 27.469c-21.844 59.238-34.337 97.729-43.838 138.668-1.484 6.37-1.484 6.37-2.988 12.845-5.353 23.158-8.218 38.081-9.82 53.42-2.77 26.522-.543 48.24 7.792 66.493 9.432 20.655 29.697 35.43 52.819 38.786 38.518 5.592 75.683 5.194 107.515-2.048 17.914-4.073 35.638-9.405 53.03-15.942 50.352-18.932 98.861-48.472 145.846-87.52 41.11-34.26 80.008-76 120.788-127.872 3.555-4.492 3.555-4.492 7.098-8.976 12.318-15.707 18.352-25.908 20.605-36.683 2.45-11.698-7.439-23.554-15.343-19.587-3.907 1.96-7.993 6.018-14.22 13.872-4.454 5.715-6.875 8.77-9.298 11.514-9.671 10.95-19.883 22.157-30.947 33.998-18.241 19.513-36.775 38.608-63.656 65.789-13.69 13.844-30.908 25.947-49.42 35.046-29.63 14.559-56.358-3.792-53.148-36.635 2.118-21.681 7.37-44.096 15.224-65.767 17.156-47.367 31.183-85.659 62.216-170.048 13.459-36.6 19.27-52.41 26.528-72.201 21.518-58.652 38.696-105.868 55.04-151.425 20.19-56.275 31.596-98.224 36.877-141.543 3.987-32.673-5.103-63.922-25.834-85.405-22.986-23.816-55.68-34.787-96.399-34.305-45.053.535-97.607 15.256-145.963 37.783Zm308.381-388.422c-80.963-31.5-178.114 22.616-194.382 108.33-11.795 62.124 11.412 115.76 58.78 138.225 93.898 44.531 206.587-26.823 206.592-130.826.005-57.855-24.705-97.718-70.99-115.729Z"
                    fill-rule="evenodd"
                  />
                </svg>
              </Tooltip>
            </div>
            <div className="infoIcon-right">
              <DropDownList
                data={CHART_LAYOUT_OPTIONS}
                textField="text"
                dataItemKey="value"
                className="providerstatusplan-dropdown chartcolumn-selection"
                value={providerAttritionCharts.providerAttritionChartsFields}
                onChange={handleProviderAttritionChart}
              />

              <Button
                title="Expand Chart"
                togglable
                svgIcon={toggleFullScreenModeIcon}
                onClick={() => setIsWindowOpenForProviderAttritionChart(true)}
                className="expandchartBtn"
              />
              {!isExpanded ? (
                <span className="drag-handle" draggable={true} onDragStart={handleDragStart} title="Drag this chart">
                  <i class="fas fa-arrows-alt"></i>
                </span>
              ) : (
                false
              )}
            </div>
          </h5>

          <div className="innersection">
            <div className="chart-legend-set">
              {attritionSeries.map((series, idx) => (
                <span
                  key={idx}
                  className="chart-legend-item"
                  style={{
                    color: series.color,
                    opacity: series.visible ? 1 : 0.5,
                    cursor: "pointer",
                    marginRight: "12px",
                  }}
                  onClick={(e) => handleLegendItemClickForPositionAttritionChart(e, series, idx)}
                >
                  <span>{series.name}</span>
                </span>
              ))}
            </div>

            <Chart
              onRefresh={(chartOptions, themeOptions, chartInstance) => {
                if (refreshProviderAttritionChart) {
                  chartInstance.setOptions(chartOptions, themeOptions);
                }
              }}
              style={{
                height: isExpanded ? `${window.innerHeight - 200}px` : null,
              }}
            >
              <ChartLegend visible={false} />

              <ChartCategoryAxis>
                <ChartCategoryAxisItem categories={attritionCategories} title={{ text: "Quarter" }} />
              </ChartCategoryAxis>

              <ChartValueAxis>
                <ChartValueAxisItem title={{ text: "Values" }} />
              </ChartValueAxis>

              <ChartSeries>
                {attritionSeries.map((series, idx) => (
                  <ChartSeriesItem
                    key={idx}
                    type={series.type}
                    data={series.data}
                    name={series.name}
                    color={series.color}
                    opacity={series.opacity || 1}
                    markers={series.markers}
                    visible={series.visible === 1}
                  />
                ))}
              </ChartSeries>

              <ChartTooltip render={renderTooltip} />
            </Chart>
          </div>
        </>
      ) : (
        <div className="nodata-overlay">
          <h3>No Data</h3>
        </div>
      )
    ) : (
      loadingPanel
    );
  };

  const handleSpProviderPositionChart = async (e) => {
    setisspeclityProviderStatusAndPlanDataLoading(true);

    setProviderSpecialtyCharts({
      ...providerSpecialtyCharts,
      providerSpChartFields: e.value,
    });
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    await saveChartLayoutToAPI("provider_status_by_specialty", e.value.parse_value);

    timeout.current = setTimeout(() => {
      setIsProviderStatusAndPlanDataLoading(false);
      setisspeclityProviderStatusAndPlanDataLoading(false);
    }, 500);
  };

  const handleActiveProviderChart = async (e) => {
    setIsPositionDataLoading(true);

    setActiveProviderCharts({
      ...activeProviderCharts,
      providerActiveChartFields: e.value,
    });

    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    await saveChartLayoutToAPI("active_providers_by_specialty", e.value.parse_value);

    timeout.current = setTimeout(() => {
      setIsPositionDataLoading(false);
      setLayoutVersion((prev) => prev + 1);
    }, 500);
  };

  const handleProviderTrendChart = async (e) => {
    setProviderTrendCharts({
      ...providerTrendCharts,
      providerTrendChartFields: e.value,
    });
    setProviderSummaryLoading(true);
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => {
      setIsProviderStatusAndPlanDataLoading(false);
      setProviderSummaryLoading(false);
    }, 500);
  };

  const handleTopProviderGroup = async (e) => {
    setTopProviderGroupCharts({
      ...topProviderGroupCharts,
      providerTopGroupChartFields: e.value,
    });
    setIsGroupSpecialtyPositionDataLoading(true);
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => {
      setIsGroupSpecialtyPositionDataLoading(false);
    }, 500);
  };

  const handleTopProviderSpecialtyChart = async (e) => {
    setTopProviderSpecialtyCharts({
      ...topProviderSpecialtyCharts,
      providerTopSpecialtyChartFields: e.value,
    });
    setIsSpecialtyPositionDataLoading(true);
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => {
      setIsSpecialtyPositionDataLoading(false);
    }, 500);
  };
  const handleProviderRententionChart = async (e) => {
    setProviderRrententionCharts({
      ...providerRrententionCharts,
      providerRrententionChartsFields: e.value,
    });
    setProviderRetentionLoading(true);
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => {
      setProviderRetentionLoading(false);
    }, 500);
  };

  const handleProviderAttritionChart = async (e) => {
    setProviderAttritionCharts({
      ...providerAttritionCharts,
      providerAttritionChartsFields: e.value,
    });
    setAttritionChartLoading(true);
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => {
      setAttritionChartLoading(false);
    }, 500);
  };

  const handleProviderAgeChart = async (e) => {
    setProviderAgeExperienceCharts({
      ...providerAgeExperienceCharts,
      providerAgeExperienceChartsFields: e.value,
    });
    setProviderAgeExperienceLoading(true);
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    await saveChartLayoutToAPI("provider_age", e.value.parse_value);

    timeout.current = setTimeout(() => {
      setProviderAgeExperienceLoading(false);
    }, 500);
  };
  const handleProviderTurnoverDataChart = async (e) => {
    setProviderTurnoverDataCharts({
      ...providerTurnoverDataCharts,
      providerTurnoverDataChartsFields: e.value,
    });
    setTurnoverChartLoading(true);
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    await saveChartLayoutToAPI("provider_turnover", e.value.parse_value);

    timeout.current = setTimeout(() => {
      setTurnoverChartLoading(false);
    }, 500);
  };
  const handleProviderArDataChart = async (e) => {
    setProviderArDataCharts({
      ...providerArDataCharts,
      providerCountDataChartsFields: e.value,
    });
    setProviderARChartLoading(true);
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    await saveChartLayoutToAPI("provider_count", e.value.parse_value);

    timeout.current = setTimeout(() => {
      setProviderARChartLoading(false);
    }, 500);
  };

  const getBlueGradient = (value, maxValue) => {
    const ratio = Math.min(value / maxValue, 1);
    const startColor = { r: 227, g: 242, b: 253 };
    const endColor = { r: 13, g: 71, b: 161 };

    const r = Math.round(startColor.r + (endColor.r - startColor.r) * ratio);
    const g = Math.round(startColor.g + (endColor.g - startColor.g) * ratio);
    const b = Math.round(startColor.b + (endColor.b - startColor.b) * ratio);

    return `rgb(${r}, ${g}, ${b})`;
  };
  const handleDrilldown = (dataItem) => {
    if (dataItem?.nativeEvent?.button === 2) {
      return;
    }
    const clickedData = dataItem.dataItem?.spe_data;

    if (!clickedData || clickedData.length === 0) return;

    const xCategories = [...new Set(clickedData.map((item) => item.category_axis_x))].map((value) => ({ value }));

    const yCategories = [...new Set(clickedData.map((item) => item.category_axis_y))].map((value) => ({ value }));

    const xMap = Object.fromEntries(xCategories.map((c, i) => [c.value, i]));
    const yMap = Object.fromEntries(yCategories.map((c, i) => [c.value, i]));

    const maxValue = Math.max(...clickedData.map((item) => Number(item.series_data) || 0)) || 1;

    const drillData = [];

    yCategories.forEach((y) => {
      xCategories.forEach((x) => {
        const found = clickedData.find((item) => item.category_axis_x === x.value && item.category_axis_y === y.value);

        const value = found ? Number(found.series_data) : 0;

        drillData.push({
          xNumeric: xMap[x.value],
          yNumeric: yMap[y.value],
          categoryX: x.value,
          categoryY: y.value,
          value,
          valueLabel: value > 0 ? `${value}%` : "0",
          color: getBlueGradient(value, maxValue),
          in_age_num: found ? found.age_no : null,
          provider_count: found ? found.provider_count : 0,
        });
      });
    });

    setDrilldownXcategoryData(xCategories);
    setDrilldownYcategoryData(yCategories);
    setDrilldownData(drillData);
    let breadcrumbLabel = "";
    const categoryX = dataItem.dataItem.categoryX;
    const categoryY = dataItem.dataItem.categoryY;
    if (dataItem.dataItem.isregionClick) {
      breadcrumbLabel = `${categoryX} (Age Bucket: ${categoryY})`;
    }
    setAgeValue(categoryY);
    setRegionValue(categoryX);
    setDrilldownState({
      steps: [
        {
          seriesName: "Region vs Hospital",
          drilldownValue: breadcrumbLabel,
        },
      ],
    });
  };

  const handleBack = () => {
    setDrilldownData(null);
    setDrilldownState("");
  };

  const handleMouseLeave = () => {
    setTooltipVisible(true);
  };
  const renderProviderAgeExperienceChart = (isExpanded, handleDragStart) => {
    return !providerAgeExperienceLoading ? (
      <>
        {!isExpanded ? (
          <h5 className="chart-title">
            <div className="charttitle-left">
              Age Analysis
              <Tooltip anchorElement="target" position="bottom" openDelay={100}>
                <i
                  class="fas fa-info-circle"
                  title={" Displays the distribution of providers by age across regions, hospitals, and specialties."}
                ></i>
              </Tooltip>
            </div>
            <div className="infoIcon-right">
              <DropDownList
                data={TWO_LAYOUT_OPTIONS}
                textField="text"
                dataItemKey="value"
                className="providerstatusplan-dropdown chartcolumn-selection"
                value={providerAgeExperienceCharts.providerAgeExperienceChartsFields}
                onChange={handleProviderAgeChart}
              />

              <Button
                title="Expand Chart"
                togglable
                svgIcon={toggleFullScreenModeIcon}
                onClick={() => setIsWindowOpenForProviderAgeExperienceChart(true)}
                className="expandchartBtn"
              />

              <span className="drag-handle" draggable={true} onDragStart={handleDragStart} title="Drag this chart">
                <i class="fas fa-arrows-alt"></i>
              </span>
            </div>
          </h5>
        ) : (
          false
        )}
        {providerAgeExperienceData.length > 0 ? (
          <div className="innersection">
            <div style={{ position: "relative" }}>
              <ChartBreadcrumb
                drilldownState={drilldownState}
                onDrilldownStateChange={handleBack}
                rootItem={{
                  text: "Region",
                }}
                onMouseLeave={handleMouseLeave}
              />

              {drilldownData ? (
                <div>
                  <ChartNavigation
                    min={
                      !isExpanded
                        ? ageAnalysisDrilldownChartNav.range.min
                        : ageAnalysisDrilldownChartNavExpanded.range.min
                    }
                    max={
                      !isExpanded
                        ? ageAnalysisDrilldownChartNav.range.max
                        : ageAnalysisDrilldownChartNavExpanded.range.max
                    }
                    totalItems={drilldownXcategoryData?.length || 0}
                    yMin={
                      !isExpanded
                        ? ageAnalysisDrilldownChartYAxisNav.range.min
                        : ageAnalysisDrilldownChartYAxisNavExpanded.range.min
                    }
                    yMax={
                      !isExpanded
                        ? ageAnalysisDrilldownChartYAxisNav.range.max
                        : ageAnalysisDrilldownChartYAxisNavExpanded.range.max
                    }
                    yTotalItems={drilldownYcategoryData?.length || 0}
                    onNavigateLeft={() => handleAgeAnalysisDrilldownChartNavigateLeft(isExpanded)}
                    onNavigateRight={() => handleAgeAnalysisDrilldownChartNavigateRight(isExpanded)}
                    onNavigateUp={() => handleAgeAnalysisDrilldownChartNavigateUp(isExpanded)}
                    onNavigateDown={() => handleAgeAnalysisDrilldownChartNavigateDown(isExpanded)}
                    onReset={() => handleAgeAnalysisDrilldownChartReset(isExpanded)}
                    enableYAxis={true}
                    rightOffset={(drilldownXcategoryData?.length || 0) === 1 ? 100 : 0}
                  />

                  <Chart
                    key={`age-analysis-drilldown-chart-${!isExpanded ? ageAnalysisDrilldownChartNav.range.min : ageAnalysisDrilldownChartNavExpanded.range.min}-${!isExpanded ? ageAnalysisDrilldownChartNav.range.max : ageAnalysisDrilldownChartNavExpanded.range.max}-${!isExpanded ? ageAnalysisDrilldownChartYAxisNav.range.min : ageAnalysisDrilldownChartYAxisNavExpanded.range.min}-${!isExpanded ? ageAnalysisDrilldownChartYAxisNav.range.max : ageAnalysisDrilldownChartYAxisNavExpanded.range.max}`}
                    className="age-analysis-drilldown-chart"
                    onRefresh={(chartOptions, themeOptions, chartInstance) => {
                      if (refreshProviderAgeExperienceChart) {
                        chartInstance.setOptions(chartOptions, themeOptions);
                      }
                    }}
                    style={{
                      height: isExpanded ? `${window.innerHeight - 200}px` : "500px",
                    }}
                    zoomable={false}
                    pannable={false}
                  >
                    <ChartSeries>
                      <ChartSeriesItem
                        type="heatmap"
                        data={drilldownData}
                        xField="xNumeric"
                        yField="yNumeric"
                        field="value"
                        colorField="color"
                        width={"12px"}
                        labels={{
                          visible: true,
                          content: (e) =>
                            e.dataItem && e.dataItem.valueLabel != null ? String(e.dataItem.valueLabel) : "",
                        }}
                      />
                    </ChartSeries>

                    <ChartXAxis>
                      <ChartXAxisItem
                        min={
                          !isExpanded
                            ? ageAnalysisDrilldownChartNav.range.min
                            : ageAnalysisDrilldownChartNavExpanded.range.min
                        }
                        max={
                          !isExpanded
                            ? ageAnalysisDrilldownChartNav.range.max
                            : ageAnalysisDrilldownChartNavExpanded.range.max
                        }
                        labels={{
                          step: 1,
                          rotation: drilldownXcategoryData.length > 5 ? -45 : 0,
                          content: (e) => String(drilldownXcategoryData[e.value]?.value ?? ""),
                        }}
                        title={{
                          text: "Specialty",
                          color: "#007eff",
                        }}
                      />
                    </ChartXAxis>

                    <ChartYAxis>
                      <ChartYAxisItem
                        min={
                          !isExpanded
                            ? ageAnalysisDrilldownChartYAxisNav.range.min
                            : ageAnalysisDrilldownChartYAxisNavExpanded.range.min
                        }
                        max={
                          !isExpanded
                            ? ageAnalysisDrilldownChartYAxisNav.range.max
                            : ageAnalysisDrilldownChartYAxisNavExpanded.range.max
                        }
                        labels={{
                          step: 1,
                          content: (e) => String(drilldownYcategoryData[e.value]?.value ?? ""),
                        }}
                        title={{
                          text: "Hospitals",
                          color: "#007eff",
                        }}
                      />
                    </ChartYAxis>

                    <ChartTooltip
                      visible={tooltipVisible}
                      render={(e) => {
                        const { dataItem } = e.point;
                        return (
                          <div>
                            Specialty:
                            {dataItem.categoryX}
                            <br />
                            Age Bucket: {ageValue}
                            <>
                              <br />
                              Region: {regionValue}
                              <br />
                              Hospital: {dataItem.categoryY}
                              <br />
                              Providers: {dataItem.provider_count}
                            </>
                          </div>
                        );
                      }}
                    />
                  </Chart>
                </div>
              ) : (
                <>
                  <ChartNavigation
                    min={!isExpanded ? ageAnalysisMainChartNav.range.min : ageAnalysisMainChartNavExpanded.range.min}
                    max={!isExpanded ? ageAnalysisMainChartNav.range.max : ageAnalysisMainChartNavExpanded.range.max}
                    totalItems={providerAgeExperienceXCategories?.length || 0}
                    onNavigateLeft={() => handleAgeAnalysisMainChartNavigateLeft(isExpanded)}
                    onNavigateRight={() => handleAgeAnalysisMainChartNavigateRight(isExpanded)}
                    onReset={() => handleAgeAnalysisMainChartReset(isExpanded)}
                  />

                  <Chart
                    key={`age-analysis-main-chart-${!isExpanded ? ageAnalysisMainChartNav.range.min : ageAnalysisMainChartNavExpanded.range.min}-${!isExpanded ? ageAnalysisMainChartNav.range.max : ageAnalysisMainChartNavExpanded.range.max}`}
                    onRefresh={(chartOptions, themeOptions, chartInstance) => {
                      if (refreshProviderAgeExperienceChart) {
                        chartInstance.setOptions(chartOptions, themeOptions);
                      }
                    }}
                    style={{
                      height: isExpanded ? `${window.innerHeight - 200}px` : "500px",
                    }}
                    zoomable={false}
                    pannable={false}
                    onSeriesClick={handleDrilldown}
                  >
                    <ChartSeries>
                      <ChartSeriesItem
                        type="heatmap"
                        data={providerAgeExperienceData}
                        xField="xNumeric"
                        yField="yNumeric"
                        field="value"
                        colorField="color"
                        width={"12px"}
                        labels={{
                          visible: true,
                          content: (e) =>
                            e.dataItem && e.dataItem.valueLabel != null ? String(e.dataItem.valueLabel) : "",
                        }}
                      />
                    </ChartSeries>

                    <ChartXAxis>
                      <ChartXAxisItem
                        min={
                          !isExpanded ? ageAnalysisMainChartNav.range.min : ageAnalysisMainChartNavExpanded.range.min
                        }
                        max={
                          !isExpanded ? ageAnalysisMainChartNav.range.max : ageAnalysisMainChartNavExpanded.range.max
                        }
                        labels={{
                          step: 1,
                          rotation: providerAgeExperienceXCategories.length > 5 ? -45 : 0,
                          content: (e) => String(providerAgeExperienceXCategories[e.value]?.value ?? ""),
                        }}
                        title={{
                          text: "Region",
                          color: "#007eff",
                        }}
                      />
                    </ChartXAxis>

                    <ChartYAxis>
                      <ChartYAxisItem
                        min={0}
                        max={providerAgeExperienceYCategories?.length || 10}
                        labels={{
                          step: 1,
                          content: (e) => String(providerAgeExperienceYCategories[e.value]?.value ?? ""),
                        }}
                        title={{
                          text: "Age Bucket",
                          color: "#007eff",
                        }}
                      />
                    </ChartYAxis>

                    <ChartTooltip
                      visible={tooltipVisible}
                      render={(e) => {
                        const { dataItem } = e.point;
                        return (
                          <div>
                            Region: {dataItem.categoryX}
                            <br />
                            Age Bucket: {dataItem.categoryY}
                          </div>
                        );
                      }}
                    />
                  </Chart>
                </>
              )}
            </div>
          </div>
        ) : (
          <div className="innersection">
            <div className="nodata-overlay" style={{ height: "400px", backgroundColor: "white" }}>
              <h3>No Data Found</h3>
            </div>
          </div>
        )}
      </>
    ) : (
      loadingPanel
    );
  };
  const renderProviderTurnOverChart = (isExpanded, handleDragStart) => {
    const axisCrossingValue = [32, 0];
    return !turnoverChartLoading ? (
      <>
        {!isExpanded ? (
          <h5 className="chart-title">
            <div className="charttitle-left">
              Turnover rate by Service Time (Tenure)
              <Tooltip anchorElement="target" position="bottom" openDelay={100}>
                <i
                  class="fas fa-info-circle"
                  title={
                    "Displays provider tenure distribution by quarter for the last 2 years, along with the overall turnover rate trend."
                  }
                ></i>
              </Tooltip>
            </div>
            <div className="infoIcon-right">
              <DropDownList
                data={TWO_LAYOUT_OPTIONS}
                textField="text"
                dataItemKey="value"
                className="providerstatusplan-dropdown chartcolumn-selection"
                value={providerTurnoverDataCharts.providerTurnoverDataChartsFields}
                onChange={handleProviderTurnoverDataChart}
              />

              <Button
                title="Expand Chart"
                togglable
                svgIcon={toggleFullScreenModeIcon}
                onClick={() => {
                  setIsWindowOpenForProviderTurnoverChart(true);
                  setRefreshProviderChart(false);
                  setRefreshpositionTypeChart(false);
                  setRefreshSpecialtyProviderChart(false);
                  setRefreshChart(false);
                  setRefreshCompSpecialtyProviderChart(false);
                }}
                className="expandchartBtn"
              />

              <span className="drag-handle" draggable={true} onDragStart={handleDragStart} title="Drag this chart">
                <i class="fas fa-arrows-alt"></i>
              </span>
            </div>
          </h5>
        ) : (
          false
        )}
        {turnoverCategories.length > 0 ? (
          <div className="innersection">
            <div className="chart-legend-set">
              {sortedTurnoverSeries.map((series, idx) => (
                <span
                  key={idx}
                  className="chart-legend-item"
                  style={{
                    color: series.color,
                    opacity: series.visible ? 1 : 0.5,
                    cursor: "pointer",
                    marginRight: "12px",
                  }}
                  onClick={(e) => handleLegendItemClickForPositionTurnOverChart(e, series, idx)}
                >
                  <span>{series.name}</span>
                </span>
              ))}
            </div>

            <ChartNavigation
              min={!isExpanded ? turnoverChartNav.range.min : turnoverChartNavExpanded.range.min}
              max={!isExpanded ? turnoverChartNav.range.max : turnoverChartNavExpanded.range.max}
              totalItems={turnoverCategories.length}
              onNavigateLeft={() => handleTurnoverChartNavigateLeft(isExpanded)}
              onNavigateRight={() => handleTurnoverChartNavigateRight(isExpanded)}
              onReset={() => handleTurnoverChartReset(isExpanded)}
            />

            <Chart
              key={`turnover-chart-${!isExpanded ? turnoverChartNav.range.min : turnoverChartNavExpanded.range.min}-${!isExpanded ? turnoverChartNav.range.max : turnoverChartNavExpanded.range.max}`}
              style={{
                height: isExpanded ? `${window.innerHeight - 200}px` : "500px",
              }}
              onRefresh={(chartOptions, themeOptions, chartInstance) => {
                if (refreshProviderTurnoverChart) {
                  chartInstance.setOptions(chartOptions, themeOptions);
                }
              }}
            >
              <ChartCategoryAxis>
                <ChartCategoryAxisItem
                  categories={turnoverCategories}
                  min={!isExpanded ? turnoverChartNav.range.min : turnoverChartNavExpanded.range.min}
                  max={!isExpanded ? turnoverChartNav.range.max : turnoverChartNavExpanded.range.max}
                  axisCrossingValue={axisCrossingValue}
                  title={{
                    text: "Quarters",
                    color: "#007eff",
                  }}
                />
              </ChartCategoryAxis>

              <ChartLegend visible={false} />

              <ChartSeries>
                {turnoverSeries.map((item, idx) => (
                  <ChartSeriesItem
                    key={idx}
                    type={item.type}
                    data={item.data}
                    name={item.name}
                    color={item.color}
                    axis={item.axis}
                    stack={item.type === "area"}
                    highlight={{ visible: false }}
                  />
                ))}
              </ChartSeries>

              <ChartTooltip
                render={(e) => (
                  <div>
                    Value : {e.point.dataItem.value}%
                    <br />
                    Year: {e.point.category}
                    <br />
                    Providers: {e.point.dataItem.provider_count}
                  </div>
                )}
              />

              <ChartValueAxis>
                <ChartValueAxisItem
                  name="rightAxis"
                  position="right"
                  title={{
                    text: "Turnover Rate (%)",
                    visible: true,
                    color: "#007eff",
                  }}
                />
                <ChartValueAxisItem
                  name="leftAxis"
                  title={{
                    text: "% Distribution by Service Time (Tenure)",
                    visible: true,
                    color: "#007eff",
                  }}
                  max={100}
                />
              </ChartValueAxis>
            </Chart>
          </div>
        ) : (
          <div className="innersection">
            <div className="nodata-overlay" style={{ height: "400px", backgroundColor: "white" }}>
              <h3>No Data Found</h3>
            </div>
          </div>
        )}
      </>
    ) : (
      loadingPanel
    );
  };

  const renderProviderCountChart = (isExpanded, handleDragStart) => {
    return !providerARChartLoading ? (
      <>
        {!isExpanded ? (
          <h5 className="chart-title">
            <div className="charttitle-left">
              Processed providers by rolling 4 months
              <Tooltip anchorElement="target" position="bottom" openDelay={100}>
                <i class="fas fa-info-circle" title={"Displays the distribution of providers ."}></i>
              </Tooltip>
            </div>
            <div className="infoIcon-right">
              <DropDownList
                data={ALL_LAYOUT_OPTIONS}
                textField="text"
                dataItemKey="value"
                className="providerstatusplan-dropdown chartcolumn-selection"
                value={providerArDataCharts.providerCountDataChartsFields}
                onChange={handleProviderArDataChart}
              />

              <Button
                title="Expand Chart"
                togglable
                svgIcon={toggleFullScreenModeIcon}
                onClick={() => {
                  setIsWindowOpenForProviderArChart(true);
                  setRefreshProviderChart(false);
                  setRefreshpositionTypeChart(false);
                  setRefreshSpecialtyProviderChart(false);
                  setRefreshChart(false);
                }}
                className="expandchartBtn"
              />

              <span className="drag-handle" draggable={true} onDragStart={handleDragStart} title="Drag this chart">
                <i class="fas fa-arrows-alt"></i>
              </span>
            </div>
          </h5>
        ) : (
          false
        )}
        {providerARCategories.length > 0 ? (
          <div className="innersection">
            <div className="chart-legend-set">
              {providerARSeries.map((series, idx) => (
                <span
                  key={idx}
                  className="chart-legend-item"
                  style={{
                    color: series.color,
                    opacity: series.visible ? 1 : 0.5,
                    cursor: "pointer",
                    marginRight: "12px",
                  }}
                  onClick={(e) => handleLegendItemClickForProviderArCount(e, series, idx)}
                >
                  <span>{series.name}</span>
                </span>
              ))}
            </div>

            <ChartNavigation
              min={!isExpanded ? providerCountChartNav.range.min : providerCountChartNavExpanded.range.min}
              max={!isExpanded ? providerCountChartNav.range.max : providerCountChartNavExpanded.range.max}
              totalItems={providerARCategories.length}
              onNavigateLeft={() => handleProviderCountChartNavigateLeft(isExpanded)}
              onNavigateRight={() => handleProviderCountChartNavigateRight(isExpanded)}
              onReset={() => handleProviderCountChartReset(isExpanded)}
            />

            <Chart
              key={`provider-count-chart-${!isExpanded ? providerCountChartNav.range.min : providerCountChartNavExpanded.range.min}-${!isExpanded ? providerCountChartNav.range.max : providerCountChartNavExpanded.range.max}`}
              style={{
                height: isExpanded ? `${window.innerHeight - 200}px` : "500px",
              }}
              onRefresh={(chartOptions, themeOptions, chartInstance) => {
                if (refreshProviderARChart) {
                  chartInstance.setOptions(chartOptions, themeOptions);
                }
              }}
            >
              <ChartCategoryAxis>
                <ChartCategoryAxisItem categories={providerARCategories} />
              </ChartCategoryAxis>
              <ChartCategoryAxis>
                <ChartCategoryAxisItem
                  categories={providerARCategories}
                  min={!isExpanded ? providerCountChartNav.range.min : providerCountChartNavExpanded.range.min}
                  max={!isExpanded ? providerCountChartNav.range.max : providerCountChartNavExpanded.range.max}
                  title={{
                    text: "Month",
                    font: "bold 20px",
                    color: "#007eff",
                  }}
                />
              </ChartCategoryAxis>

              <ChartValueAxis>
                <ChartValueAxisItem
                  title={{
                    text: "Providers",
                    font: "bold 20px",
                    color: "#007eff",
                  }}
                />
              </ChartValueAxis>
              <ChartLegend visible={false} />

              <ChartSeries>
                {providerARSeries.map((s, idx) => (
                  <ChartSeriesItem key={idx} {...s} />
                ))}
              </ChartSeries>

              <ChartTooltip render={renderProviderCountTooltip} />
            </Chart>
          </div>
        ) : (
          <div className="innersection">
            <div className="nodata-overlay" style={{ height: "400px", backgroundColor: "white" }}>
              <h3>No Data Found</h3>
            </div>
          </div>
        )}
      </>
    ) : (
      loadingPanel
    );
  };

  const handleChartDragStart = (chartId) => {
    const draggedElement = document.querySelector(`[data-chart-id="${chartId}"]`);
    if (draggedElement) {
      draggedElement.classList.add("dragging");
      document.body.setAttribute("data-dragging-chart", chartId);
      document.body.style.cursor = "grabbing";
      document.querySelectorAll(".draggable-chart").forEach((chart) => {
        if (chart !== draggedElement) {
          chart.classList.add("drop-target");
        }
      });
    }
  };

  const handleChartDragOver = (chartId) => {
    const draggedId = document.body.getAttribute("data-dragging-chart");
    if (!draggedId || draggedId === chartId) return;

    if (document.querySelector(".drag-over")) {
      document.querySelectorAll(".drag-over").forEach((el) => el.classList.remove("drag-over"));
    }

    const dropTarget = document.querySelector(`[data-chart-id="${chartId}"]`);
    if (dropTarget) {
      dropTarget.classList.add("drag-over");
      const draggedIndex = chartOrder.indexOf(draggedId);
      const dropIndex = chartOrder.indexOf(chartId);

      dropTarget.classList.toggle("drop-above", draggedIndex > dropIndex);
      dropTarget.classList.toggle("drop-below", draggedIndex < dropIndex);
    }
  };

  const handleChartDrop = async (draggedId, targetId) => {
    if (draggedId === targetId) return;

    const newOrder = [...chartOrder];
    const draggedIndex = newOrder.indexOf(draggedId);
    const targetIndex = newOrder.indexOf(targetId);

    newOrder.splice(draggedIndex, 1);
    const adjustedTargetIndex = draggedIndex < targetIndex ? targetIndex - 1 : targetIndex;
    newOrder.splice(adjustedTargetIndex, 0, draggedId);

    setChartOrder(newOrder);

    await saveChartOrder(newOrder);
  };

  const saveChartOrder = async (newOrder) => {
    try {
      const normalizeChartId = (chartId) => (chartId === "providerTurnover" ? "providerturnover" : chartId);
      for (let index = 0; index < newOrder.length; index += 1) {
        const chartId = normalizeChartId(newOrder[index]);
        const labelName = chartIdToLabelMap[chartId];
        if (!labelName) continue;

        await Action.updateLayout({
          in_tenant_id: cookiesData.out_tenant_id,
          in_user_id: cookiesData.out_user_id,
          label_name: labelName,
          layout_value: null,
          in_pod_order: index + 1,
        });
      }
    } catch (error) {
      console.error("Failed to save chart order:", error);
    }
  };
  const PROVIDER_POSITION_DASHBOARD_KB_URL =
    "https://procareportal.atlassian.net/wiki/spaces/CSS/pages/2905866259/Provider+Position+Dashboard+Specification";

  const AddNewLink = () => {
    return (
      <a
        className="cta-small"
        onClick={(e) => {
          e.preventDefault();
          history.push("/prv_pos", { openAddForm: true });
        }}
        title="Add New Provider Position"
      >
        <i className="fas fa-plus"></i> Add New Provider Position
      </a>
    );
  };

  const handleMenuItemClick = (module) => {
    switch (module) {
      case "manageCustomType":
        setShow((prev) => ({ ...prev, isManageCustomType: !prev.isManageCustomType }));
        break;
      case "dtuLogs":
        setShow((prev) => ({ ...prev, dtuLogs: !prev.dtuLogs }));
        break;
      default:
        break;
    }
  };

  const handleUpload = (e) => {
    e.preventDefault();
    setShow((prev) => ({ ...prev, dtuUpload: !prev.dtuUpload }));
  };

  const HeaderPreActionLinks = () => {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <a
          className="cta-small"
          href={PROVIDER_POSITION_DASHBOARD_KB_URL}
          target="_blank"
          rel="noopener noreferrer"
          title="Provider Position Dashboard Specification"
        >
          <i className="fas fa-book"></i> Dashboard Guide
        </a>
      </div>
    );
  };

  return (
    <>
      <div className="Main eventspage event-drp">
        <div className="content">
          <div className="content-head eventhead">
            <HeaderPage
              pageProps={restProps}
              headerConfig={{
                title: "Provider-Position",
                id: "provider-position",
                header_pre_actions_fx: HeaderPreActionLinks,
                add_new_fx: AddNewLink,
                upload_fx: handleUpload,
                action_menu: {
                  dtuLog: { fx: handleMenuItemClick },
                  manageType: {
                    fx: handleMenuItemClick,
                    items: [
                      {
                        caption: "Manage Custom Fields",
                        module: "manageCustomType",
                      },
                    ],
                  },
                },
              }}
            />
          </div>
          <div className="content-body providerdashboard">
            <div className="filtercontainer providerdash-gridview-filter">
              <div className="eventdash-filter-row">
                <div className="eventdash-filter-bar eventdash-filter-bar--grid">
                  <div className="eventdash-filter-section eventdash-filter-section-grid">
                    <span className="eventdash-filter-section-title">
                      <p className="gridviewtitle">Grid View</p>
                      <p className="gridviewsubtitle">
                        Filters and opens the data grid. Doesn't change the charts below
                      </p>
                    </span>
                    <div className="eventdash-filter-section-controls">
                      <div className="k-form-field-wrap-popup valueDropdown">
                        <Label>Specialty:</Label>
                        <MultiSelect
                          name="specialtyDataValue"
                          dataItemKey="id"
                          textField="text"
                          data={specialtyDataFields.specialtyData}
                          filterable
                          value={specialtyDataFields.specialtyDataValue}
                          autoClose={false}
                          filter={specialtyDataFields.filterValue}
                          loading={specialtyDataFields.isSpecialtyDataLoading}
                          disabled={specialtyDataFields.isSpecialtyDataLoading}
                          onOpen={() =>
                            onOpenChange(
                              setSpecialtyDataFields,
                              specialtyDataList,
                              "specialtyData",
                              specialtyDataFields,
                              specialtyDataFields.specialtyDataValue
                            )
                          }
                          onChange={(e) =>
                            handleChangeDropdownValue(
                              e,
                              "specialtyDataValue",
                              setSpecialtyDataFields,
                              specialtyDataList,
                              specialtyDataFields.specialtyDataValue,
                              specialtyDataFields
                            )
                          }
                          onFilterChange={(e) =>
                            filterChange(e, setSpecialtyDataFields, specialtyDataList, "specialtyData")
                          }
                          onBlur={() => handleBlurDropdown(setSpecialtyDataFields, "specialtyData")}
                        />
                      </div>
                      <div className="k-form-field-wrap-popup valueDropdown">
                        <Label>Group:</Label>
                        <MultiSelect
                          name="groupDataValue"
                          dataItemKey="id"
                          textField="text"
                          data={groupDataFields.groupData}
                          filterable
                          value={groupDataFields.groupDataValue}
                          autoClose={false}
                          filter={groupDataFields.filterValue}
                          loading={groupDataFields.isGroupDataLoading}
                          disabled={groupDataFields.isGroupDataLoading}
                          onOpen={() =>
                            onOpenChange(
                              setGroupDataFields,
                              groupDataList,
                              "groupData",
                              groupDataFields,
                              groupDataFields.groupDataValue
                            )
                          }
                          onChange={(e) =>
                            handleChangeDropdownValue(
                              e,
                              "groupDataValue",
                              setGroupDataFields,
                              groupDataList,
                              groupDataFields.groupDataValue,
                              groupDataFields
                            )
                          }
                          onFilterChange={(e) => filterChange(e, setGroupDataFields, groupDataList, "groupData")}
                          onBlur={() => handleBlurDropdown(setGroupDataFields, "groupData")}
                        />
                      </div>
                      <div className="k-form-field-wrap-popup valueDropdown">
                        <Label>Employee ID:</Label>
                        <MultiSelect
                          name="employeeDataValue"
                          dataItemKey="id"
                          textField="text"
                          data={employeeDataFields.employeeData}
                          filterable
                          filter={employeeDataFields.filterValue}
                          value={employeeDataFields.employeeDataValue}
                          autoClose={false}
                          loading={employeeDataFields.isEmployeeDataLoading}
                          disabled={employeeDataFields.isEmployeeDataLoading}
                          onOpen={() =>
                            onOpenChange(
                              setEmployeeDataFields,
                              employeeDataList,
                              "employeeData",
                              employeeDataFields,
                              employeeDataFields.employeeDataValue
                            )
                          }
                          onChange={(e) =>
                            handleChangeDropdownValue(
                              e,
                              "employeeDataValue",
                              setEmployeeDataFields,
                              employeeDataList,
                              employeeDataFields.employeeDataValue,
                              employeeDataFields
                            )
                          }
                          onFilterChange={(e) =>
                            filterChange(e, setEmployeeDataFields, employeeDataList, "employeeData")
                          }
                          onBlur={() => handleBlurDropdown(setEmployeeDataFields, "employeeData")}
                        />
                      </div>
                      <div className="k-form-field-wrap-popup valueDropdown">
                        <Label>NPI:</Label>
                        <MultiSelect
                          name="npiDataValue"
                          dataItemKey="id"
                          textField="text"
                          data={npiDataFields.npiData}
                          filterable
                          value={npiDataFields.npiDataValue}
                          autoClose={false}
                          filter={npiDataFields.filterValue}
                          loading={npiDataFields.isNpiDataLoading}
                          disabled={npiDataFields.isNpiDataLoading}
                          onOpen={() =>
                            onOpenChange(
                              setNpiDataFields,
                              npiDataList,
                              "npiData",
                              npiDataFields,
                              npiDataFields.npiDataValue
                            )
                          }
                          onChange={(e) =>
                            handleChangeDropdownValue(
                              e,
                              "npiDataValue",
                              setNpiDataFields,
                              npiDataList,
                              npiDataFields.npiDataValue,
                              npiDataFields
                            )
                          }
                          onFilterChange={(e) => filterChange(e, setNpiDataFields, npiDataList, "npiData")}
                          onBlur={() => handleBlurDropdown(setNpiDataFields, "npiData")}
                        />
                      </div>
                      <div className="k-form-field-wrap-popup valueDropdown">
                        <Label>Position Name:</Label>
                        <MultiSelect
                          name="positionDataValue"
                          dataItemKey="id"
                          textField="text"
                          data={positionDataFields.positionData}
                          filterable
                          value={positionDataFields.positionDataValue}
                          autoClose={false}
                          filter={positionDataFields.filterValue}
                          loading={positionDataFields.isPositionDataLoading}
                          disabled={positionDataFields.isPositionDataLoading}
                          onOpen={() =>
                            onOpenChange(
                              setPositionDataFields,
                              positionDataList,
                              "positionData",
                              positionDataFields,
                              positionDataFields.positionDataValue
                            )
                          }
                          onChange={(e) =>
                            handleChangeDropdownValue(
                              e,
                              "positionDataValue",
                              setPositionDataFields,
                              positionDataList,
                              positionDataFields.positionDataValue,
                              positionDataFields
                            )
                          }
                          onFilterChange={(e) =>
                            filterChange(e, setPositionDataFields, positionDataList, "positionData")
                          }
                          onBlur={() => handleBlurDropdown(setPositionDataFields, "positionData")}
                        />
                      </div>
                      <Button
                        primary
                        className="searchbtn"
                        disabled={isGridViewFilterLoading}
                        type="button"
                        onClick={handleGridViewSearch}
                        title="Search"
                      >
                        <i className="fas fa-search"></i>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="providerdashbopardcontainer">
              <div className="tilecontainer flex30 dashboard-border-shadow">
                <TileLayout
                  columns={5}
                  rowHeight={110}
                  columnWidth={200}
                  gap={{ rows: 3, columns: 5 }}
                  items={tiles}
                  className="tilelayout"
                />
              </div>
              <div className="resentsearchsection dashboard-border-shadow flex60">
                <h5 class="chart-title">Recent Searches</h5>
                <div className="nodata-overlay" style={{ height: "140px" }}>
                  <h3 className="graytitle">This feature is currently under development.</h3>
                </div>
              </div>
            </div>

            <div className="profiderdashboardleft">
              {chartOrder.map((chartId) => {
                switch (chartId) {
                  case "providerStatus":
                    return (
                      <DraggableChart
                        key={`providerStatus-${providerCharts.providerChartFields.value}-${layoutVersion}`}
                        id="providerStatus"
                        ref={providerChartRefCallback}
                        className={`dashboardsub-container ${providerCharts.providerChartFields.value}`}
                        onDragStart={handleChartDragStart}
                        onDragOver={handleChartDragOver}
                        onDrop={handleChartDrop}
                      >
                        {({ handleDragStart }) => (
                          <div className="dashboard-border-shadow providerstatusplan">
                            {renderProviderChart(false, handleDragStart)}
                          </div>
                        )}
                      </DraggableChart>
                    );

                  case "activeProviders":
                    return (
                      <DraggableChart
                        key={`${chartId}-${activeProviderCharts.providerActiveChartFields.value}-${layoutVersion}`}
                        id={chartId}
                        ref={activeProviderChartRefCallback}
                        className={`dashboardsub-container ${activeProviderCharts.providerActiveChartFields.value}`}
                        onDragStart={handleChartDragStart}
                        onDragOver={handleChartDragOver}
                        onDrop={handleChartDrop}
                      >
                        {({ handleDragStart }) => (
                          <div className="dashboard-border-shadow providerstatusplan">
                            {renderProviderStatusBySpecialtyChart(false, handleDragStart)}
                          </div>
                        )}
                      </DraggableChart>
                    );

                  case "providerSpecialty":
                    return (
                      <DraggableChart
                        key={`${chartId}-${providerSpecialtyCharts.providerSpChartFields.value}-${layoutVersion}`}
                        id={chartId}
                        ref={specialtyChartRefCallback}
                        className={`dashboardsub-container ${providerSpecialtyCharts.providerSpChartFields.value}`}
                        onDragStart={handleChartDragStart}
                        onDragOver={handleChartDragOver}
                        onDrop={handleChartDrop}
                      >
                        {({ handleDragStart }) => (
                          <div className="dashboard-border-shadow providerstatusplan">
                            {renderProviderSpecialtyChart(false, handleDragStart)}
                          </div>
                        )}
                      </DraggableChart>
                    );

                  case "providerageexperience":
                    if (cookiesData.out_tenant_id === "cmnspirit001") {
                      return (
                        <DraggableChart
                          key={chartId}
                          id={chartId}
                          className={`dashboardsub-container ${providerAgeExperienceCharts.providerAgeExperienceChartsFields.value}`}
                          ref={ageAnalysisChartRefCallback}
                          onDragStart={handleChartDragStart}
                          onDragOver={handleChartDragOver}
                          onDrop={handleChartDrop}
                        >
                          {({ handleDragStart }) => (
                            <div className="dashboard-border-shadow positiontypechart providerstatusplan">
                              {renderProviderAgeExperienceChart(false, handleDragStart)}
                            </div>
                          )}
                        </DraggableChart>
                      );
                    }
                    return null;

                  case "providerturnover":
                    return (
                      <DraggableChart
                        key={chartId}
                        id={chartId}
                        ref={turnoverChartRefCallback}
                        className={`dashboardsub-container ${providerTurnoverDataCharts.providerTurnoverDataChartsFields.value}`}
                        onDragStart={handleChartDragStart}
                        onDragOver={handleChartDragOver}
                        onDrop={handleChartDrop}
                      >
                        {({ handleDragStart }) => (
                          <div className="dashboard-border-shadow positiontypechart">
                            {renderProviderTurnOverChart(false, handleDragStart)}
                          </div>
                        )}
                      </DraggableChart>
                    );

                  case "providerCount": {
                    const username = cookiesData?.out_user_name?.toLowerCase() || "";
                    const isAllowedUser = username.includes("ps@") || username.includes("ps2@");

                    if (!isAllowedUser) return null;

                    return (
                      <DraggableChart
                        key={chartId}
                        ref={providerCountChartRefCallback}
                        id={chartId}
                        className={`dashboardsub-container ${providerArDataCharts.providerCountDataChartsFields.value}`}
                        onDragStart={handleChartDragStart}
                        onDragOver={handleChartDragOver}
                        onDrop={handleChartDrop}
                      >
                        {({ handleDragStart }) => (
                          <div className="dashboard-border-shadow positiontypechart">
                            {renderProviderCountChart(false, handleDragStart)}
                          </div>
                        )}
                      </DraggableChart>
                    );
                  }

                  default:
                    return null;
                }
              })}
            </div>

            {isWindowOpen &&
              renderKendoWindow({
                visible: true,
                title: "Provider Status By Compensation Plan",
                onClose: () => setIsWindowOpen(false),
                width: window.innerWidth - 50,
                height: window.innerHeight - 50,
                children: (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      overflow: "hidden",
                    }}
                  >
                    <div style={{ flex: 1, minHeight: 0 }}>{renderProviderChart(true)}</div>
                  </div>
                ),
              })}
            {isWindowOpenForProviderandSpecialtyChart &&
              renderKendoWindow({
                visible: true,
                title: "Providers By Specialty & Compensation Plan",
                onClose: () => setIsWindowOpenForProviderandSpecialtyChart(false),
                width: window.innerWidth - 50,
                height: window.innerHeight - 50,
                children: (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      overflow: "hidden",
                    }}
                  >
                    <div style={{ flex: 1, minHeight: 0 }}>{renderProviderSpecialtyChart(true)}</div>
                  </div>
                ),
              })}

            {isWindowOpenForProviderandSpecialtyChartByStatus &&
              renderKendoWindow({
                visible: true,
                title: " Active Providers by Specialty",
                onClose: () => setIsWindowOpenForProviderandSpecialtyChartByStatus(false),
                width: window.innerWidth - 50,
                height: window.innerHeight - 50,

                children: (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div style={{ flex: 1, minHeight: 0 }}>{renderProviderStatusBySpecialtyChart(true)}</div>
                  </div>
                ),
              })}

            {isWindowOpenForProviderAttritionChart &&
              renderKendoWindow({
                visible: true,
                title: "Attrition % for Specialty over Years",
                onClose: () => setIsWindowOpenForProviderAttritionChart(false),
                width: window.innerWidth - 50,
                height: window.innerHeight - 50,

                children: (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      overflow: "hidden",
                    }}
                  >
                    <div style={{ flex: 1, minHeight: 0 }}>{renderProviderAttritionChart(true)}</div>
                  </div>
                ),
              })}
            {isWindowOpenForProviderAgeExperienceChart &&
              renderKendoWindow({
                visible: true,
                title: "Age Analysis",
                onClose: () => setIsWindowOpenForProviderAgeExperienceChart(false),
                width: window.innerWidth - 50,
                height: window.innerHeight - 50,

                children: (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      overflow: "hidden",
                    }}
                  >
                    <div style={{ flex: 1, minHeight: 0 }}>{renderProviderAgeExperienceChart(true)}</div>
                  </div>
                ),
              })}
            {isWindowOpenForProviderTurnoverChart &&
              renderKendoWindow({
                visible: true,
                title: "Turnover rate by Service Time (Tenure)",
                onClose: () => setIsWindowOpenForProviderTurnoverChart(false),
                width: window.innerWidth - 50,
                height: window.innerHeight - 50,

                children: (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      overflow: "hidden",
                    }}
                  >
                    <div style={{ flex: 1, minHeight: 0 }}>{renderProviderTurnOverChart(true)}</div>
                  </div>
                ),
              })}
            {isWindowOpenForProviderArChart &&
              renderKendoWindow({
                visible: true,
                title: "Processed providers by rolling 4 months",
                onClose: () => setIsWindowOpenForProviderArChart(false),
                width: window.innerWidth - 50,
                height: window.innerHeight - 50,

                children: (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      overflow: "hidden",
                    }}
                  >
                    <div style={{ flex: 1, minHeight: 0 }}>{renderProviderCountChart(true)}</div>
                  </div>
                ),
              })}
          </div>
        </div>
      </div>
      {isShow.dtuLogs && (
        <DtuBatchLogs visible={isShow} setShow={setShow} module={"provider_master"} pageProps={restProps} />
      )}
      {isShow.isManageCustomType && (
        <ManageCustomField visible={isShow.isManageCustomType} setShow={setShow} pageProps={restProps} />
      )}
      {isShow.dtuUpload && (
        <UploadDtu
          visible={isShow}
          setShow={setShow}
          title={"Upload Provider Positions"}
          pageId={"provider_position"}
          setAPICall={onUpdateChartClick}
        />
      )}
    </>
  );
};

export default React.memo(ProviderDashboard);
